/* ==========================================================================
   Frank!y homepage — hero 'De baan om het merk' (03-10-2026)
   Hoort bij sections/frankly-home-akker.liquid (markup ongewijzigd, zie de kop
   daar) en assets/frankly-akker.css. Vraagt GSAP 3.13 met DrawSVGPlugin en
   MorphSVGPlugin (in de sectie, met defer, vóór dit bestand). Start op
   [data-frankly-baan]; de sprite-sheet (assets/frankly-baan-sprites.png) staat
   in data-baan-sprites.

   Alle maten in wm (woordmerk-eenheden) van het scènevlak
   (viewBox -20 -110 703.862 292.69), alle tijden in seconden. Eén timeline
   per hero met labels (duur 7,22 s):
     stil 0 · intocht 0,3 · baan 1,0 · duik 2,05 · vol 4,46 · morph 4,75 ·
     claims 5,45 · letters 6,05.
   Het verhaal (op verzoek van de eigenaar, naar zijn voorbeeldvideo): 'Frank y'
   met de echte tube op de plek van het uitroepteken. Wat in deze tube zit,
   in stukjes (pitten van de granaatappel en stukjes aloë; de kokos is er op
   04-10 op verzoek van de eigenaar uit), vliegt het beeld in en draait
   als een ring op een schuine baan om het woord: vóór de letters langs aan
   de voorkant, erachter langs aan de achterkant, elk tollend om zijn eigen
   as. Na driekwart ronde wordt er water bij geschonken (een straal die van
   boven het beeld de mond in valt) en duiken de stukjes als een stroom van
   twee kanten de tube in (achterlangs van boven het woord, voorlangs van
   rechts van de y); bij elke hap slikt de tube en wordt hij boller.
   Als alles erin zit staat hij even overdreven vol te trillen en duwt hij de
   letters opzij. Dan knijpen de k en de y hem leeg, poef, en hij wordt het
   uitroepteken.

   DE FOTO'S in de sprite-sheet: de pitten en het stuk aloë zijn van 29-09
   (Canva). De sheet bevat ook nog stukjes en schijfjes kokos (Pexels 7662655 en
   Pixabay 4507974, vrije licentie); die gebruikt het script sinds 04-10 niet
   meer, want het reinigende gedeelte van de reiniger is volgens de PIF van kokos- óf
   palmpitolie. Bij een nieuwe bouw van de sheet kunnen ze eruit.

   HOGER EN ZONDER GLOED (04-10, op verzoek van de eigenaar): de CSS
   (.fh-hero2--hoog in assets/frankly-akker.css) knipt 64 wm van de lucht boven
   het woord weg, zodat de hero hoger staat. De baan is niet veranderd: de
   stukjes die bovenlangs gaan, de sprong naar de tube en de waterstraal gaan
   boven -46 wm even uit beeld, achter de kop van de site. De groene gloed
   (lucht en gloed in de svg) zet de sectie niet meer; waar het commentaar
   hieronder nog over 'de gloed van de svg' gaat, is dat de reden waarom iets
   zo gebouwd is, niet iets wat je nog ziet.

   HOE HET IN ELKAAR ZIT (zoek op de letter):
     REGIE   de tijden, de baan, de rolverdeling, het water en alle maten:
             bovenaan.
     A  LAGEN    twee canvassen in .fh-frankly: 'achter' onder de svg (wat
                 achter de letters langs gaat) en 'voor' erboven.
     B  SPRITES  de sheet, één keer gebakken per maat (beeld en losse zachte
                 schaduw), en tekenSprite().
     C  BAAN     baanPunt(hoek): plek, diepte en schaal op de schuine ellips.
     D  TUBE     de tubefoto in stroken op het voorste canvas, met bolprofiel,
                 golf, glans en slagschaduw; bij bol 0 gelijk aan de SVG-foto.
     E  DUIK     rolStand(rol, t): intocht, baan, sprong naar boven de mond,
                 plons erin (geknipt op de rand van de mond).
     W  WATER    de straal: de worp, de vorm, de schaduwing uit de waterfoto.
     F  SLIK/VOL tubeStand(t): bolling, golf, schok en trillen uit de happen.
     G  TIMELINE de labels, de morph, zet(), start, terugval, resize.
   Alles wat op de canvassen staat is een zuivere functie van tl.time():
   teken(t) rekent elk beeld opnieuw uit, zonder geheugen van het vorige. Zo
   geeft zet(t) op elk moment, in elke volgorde, hetzelfde beeld als spelen.
   Wat in de SVG gebeurt (morph, claims, letters) zijn tweens in de timeline;
   de timeline stuurt ook een handvol getallen van de tube (zie 'tube'). Zet
   nooit twee tweens tegelijk op dezelfde eigenschap: bij terugspoelen wint
   dan een andere dan bij vooruitspelen.

   DE WISSEL VAN FOTO NAAR CANVAS: tot de tube voor het eerst beweegt (het
   water raakt de mond) staat hij als SVG-foto in het woord (de beginstand
   blijft dus die van de svg); vanaf dan tot de poef tekent het script hem op
   de voorste laag en is de SVG-foto uit. Na de poef zijn beide lagen leeg en
   weg (display none): de eindstand is weer alleen de svg.

   GEEN RANDVERVAGING op de lagen (het oude .fh-atomen had een masker): het
   beeld loopt op elke breedte van schermrand tot schermrand, dus wat links of
   rechts het canvas verlaat, verlaat het scherm.

   Zonder GSAP: niets doen; de markup is de eindstand. Met 'Verminder
   beweging', of als de sheet of de tube niet binnen 2,5 s laadt: de rustige
   variant (rustigSpelen), zonder ingrediënten.
   QA: ?fh_t=<ms> zet de hero stil op dat moment; window.fhAkker.zet(t);
   ?fh_debug=1 tekent de baan, de wisselpunten en de duikpaden;
   ?fh_debug=tube zet de tube vanaf het begin op het canvas (om hem met de
   SVG-foto te vergelijken).
   ========================================================================== */
(function () {
  'use strict';

  /* ========================================================================
     REGIE — tijden in seconden op de timeline, maten in wm.
     ======================================================================== */

  // De labels 'duik' en 'vol' volgen uit de rolverdeling (eerste vertrek,
  // laatste hap plus 0,12 s). De morph begint op 'morph', of later als de
  // laatste hap later valt: tussen 'vol' en de morph zit altijd minstens
  // 'vol' seconden, zo lang staat de tube overdreven vol te trillen. Na de
  // morph volgt nog 2,47 s (claims, onderschrift).
  var TIJD = {
    intocht: 0.3,   // de eerste stukjes komen het beeld in
    baan: 1.0,      // de ring vormt zich (alleen een label; de laatste stukjes zijn er rond 1,5 s)
    morph: 4.75,    // M0 op zijn vroegst: de k en de y knijpen, poef, het teken
    vol: 0.27       // zo lang staat de tube minstens vol voor de morph (de eigenaar vond 0,42 te lang; korter dan 0,25 en het trillen is niet meer te zien)
  };

  // Seconden per rondje. Positief: aan de voorkant van rechts naar links,
  // achterlangs van links naar rechts (dus naar de tube toe).
  var OMLOOP = 2.6;

  // De baan: een schuine ellips om het woord. Hoek 0 = rechter uiteinde,
  // 90 = midden vóór (onderaan, vóór de letters), 180 = linker uiteinde,
  // 270 = midden achter (bovenaan, achter de letters). Op de uiteinden wisselt
  // een sprite van laag; daar moet hij dus vrij van de letters staan.
  var BAAN = {
    midden: [331.93, 60],
    rx: 430,        // halve breedte als er ruimte is (desktop)
    ry: 74,         // halve hoogte (bouwBaan maakt hem kleiner als het vlak te laag is)
    kantel: -5,     // graden; min = rechter uiteinde omhoog
    diep: 0.27,     // schaal: voor 1 + diep, achter 1 - diep
    vertrek: 286,   // hoek waar een stukje de baan achterlangs verlaat (boven het woord, links van de tube)
    woord: 332,     // halve breedte van het woord; de uitwijk van de k en de y (TUBE.spleet + TUBE.duw) telt het script erbij
    rand: 45,       // zo ver blijft de baan binnen de schermrand als dat past
    smal: 0.66,     // onder dit aantal CSS-px per wm worden de sprites groter getekend...
    smalMax: 1.08   // ...tot hooguit deze factor (telefoon; meer dekt het woord te veel af)
  };

  // De intocht: elke rol begint net buiten beeld (links voor wie achterlangs
  // naar rechts gaat, rechts voor wie voorlangs naar links gaat) en zakt in
  // 'duur' seconden op zijn baan. 'na': zo veel later begint elke volgende
  // rol; 'klein': zo groot is hij aan het begin; 'hoog': zo veel wm hoger
  // (voor) of lager (achter) begint hij.
  // Onderweg is een rol nog niet op de baan: wisselt hij dan van laag (hoek 0
  // of 180), dan hangt hij ergens boven het woord en zie je hem van achter een
  // letter naar voren springen. Daarom, per rol die tijdens zijn intocht een
  // uiteinde van de baan passeert: valt dat in het eerste deel ('vroeg') van
  // zijn intocht, dan vliegt hij tot dat uiteinde al op de laag van erna;
  // valt het later, dan is zijn intocht op het uiteinde klaar (hij staat daar
  // dan precies op de baan, vrij van de letters).
  var INTOCHT = { duur: 0.8, na: 0.022, klein: 0.7, hoog: 14, vroeg: 0.5 };

  // De ring en de stroom. De stukjes staan gelijk verdeeld over de baan, als
  // een ring. Vanaf 'start' duikt elk stukje bij het vertrekpunt dat het het
  // eerst bereikt: achterlangs (BAAN.vertrek, boven het woord) of voorlangs
  // ('voor' graden: rechts van de y, zodat de sprong niet over de tube en zijn
  // etiket gaat). Zo komen er van twee kanten om en om stukjes bij de mond
  // aan, eerst dicht op elkaar en tegen het eind één voor één van achter. De
  // volgorde van ROLLEN is de volgorde van duiken. Het punt voorlangs schuift
  // hooguit een kwart stap, zodat de twee stromen precies om en om lopen.
  var STROOM = { start: 2.1, voor: 38 };

  // De rolverdeling, in volgorde van duiken. Alleen wat in deze tube zit, en
  // alleen in stukjes (op verzoek van de eigenaar): pitten van de granaatappel
  // en stukjes aloë. Tot 04-10 stond er ook kokos in; die plekken zijn nu aloë
  // (de grote) en pitten (de kleine), met dezelfde baan, tol en volgorde, zodat
  // de timing gelijk bleef. Per rol:
  //   sprite   naam in VAKKEN (een sprite mag vaker voorkomen; een rol met een
  //            sprite die niet in VAKKEN staat doet niet mee)
  //   breedte  wm op de baan bij schaal 1 (halverwege voor en achter); op een
  //            telefoon komt daar BAAN.smal nog overheen. Niet groter dan de
  //            foto scherp kan leveren: op een groot scherm met dubbele
  //            pixels is 1 wm vooraan ruim 4 px van de sheet
  //   tol      graden per seconde om de eigen as (min = andersom); hoek0 = de
  //            hoek op t = 0
  //   r, dy    een eigen spoor: straalfactor en hoogte (wm) ten opzichte van
  //            de baan. Zo vormen de stukjes een losse band in plaats van een
  //            rijtje
  //   spiegel  -1 = gespiegeld
  //   hap      hoeveel boller de tube ervan wordt (verhouding, samen met
  //            WATER.hap)
  //   sap      kleur van de spatjes bij de hap
  // Zelden nodig: 'duik' (een eigen duikmoment in plaats van zijn beurt in de
  // stroom), 'kant' ('voor' of 'achter'), 'fase' (graden op t = 0, in plaats
  // van de plek die uit zijn duikmoment volgt) en 'in' (het moment waarop hij
  // het beeld in komt; anders TIJD.intocht + volgnummer * INTOCHT.na). Wie
  // die opgeeft staat niet meer vanzelf op zijn plek in de ring.
  var ROLLEN = [
    { sprite: 'aril1', breedte: 34, tol: 230, hoek0: 20, r: 1.0, dy: -6, hap: 0.04, sap: 'rood' },
    { sprite: 'aril4', breedte: 30, tol: -110, hoek0: 40, r: 1.04, dy: 8, hap: 0.04, sap: 'rood' },
    { sprite: 'aloe', breedte: 52, tol: 95, hoek0: 200, r: 0.96, dy: -10, hap: 0.07, sap: 'groen' },
    { sprite: 'aril3', breedte: 26, tol: -190, hoek0: 80, r: 1.03, dy: 6, hap: 0.04, sap: 'rood' },
    { sprite: 'aril2', breedte: 29, tol: 140, hoek0: 250, r: 0.98, dy: -5, hap: 0.04, sap: 'rood' },
    { sprite: 'aloe', breedte: 44, tol: -105, hoek0: 70, r: 1.03, dy: 8, spiegel: -1, hap: 0.07, sap: 'groen' },
    { sprite: 'aril5', breedte: 36, tol: 160, hoek0: 200, r: 0.95, dy: -12, hap: 0.04, sap: 'rood' },
    { sprite: 'aloe', breedte: 46, tol: -95, hoek0: 310, r: 1.02, dy: -8, hap: 0.07, sap: 'groen' },
    { sprite: 'aril2', breedte: 29, tol: 210, hoek0: 140, r: 1.05, dy: 10, hap: 0.04, sap: 'rood' },
    { sprite: 'aril3', breedte: 26, tol: -170, hoek0: 100, r: 1.0, dy: 12, hap: 0.04, sap: 'rood' },
    { sprite: 'aloe', breedte: 42, tol: -130, hoek0: 170, r: 1.02, dy: 6, spiegel: -1, hap: 0.07, sap: 'groen' },
    { sprite: 'aril4', breedte: 30, tol: -240, hoek0: 300, r: 1.02, dy: -2, spiegel: -1, hap: 0.04, sap: 'rood' },
    { sprite: 'aril5', breedte: 34, tol: 190, hoek0: 260, r: 1.04, dy: -9, spiegel: -1, hap: 0.04, sap: 'rood' },
    { sprite: 'aril1', breedte: 30, tol: -210, hoek0: 110, r: 0.94, dy: 12, spiegel: -1, hap: 0.04, sap: 'rood' },
    { sprite: 'aloe', breedte: 44, tol: 105, hoek0: 230, r: 0.99, dy: 13, spiegel: -1, hap: 0.07, sap: 'groen' },
    { sprite: 'aril5', breedte: 31, tol: 240, hoek0: 30, r: 1.06, dy: 4, hap: 0.04, sap: 'rood' },
    { sprite: 'aloe', breedte: 48, tol: -90, hoek0: 150, r: 1.0, dy: -6, hap: 0.07, sap: 'groen' },
    { sprite: 'aril2', breedte: 27, tol: 180, hoek0: 260, r: 0.96, dy: -13, spiegel: -1, hap: 0.04, sap: 'rood' },
    { sprite: 'aloe', breedte: 46, tol: 125, hoek0: 15, r: 0.97, dy: -4, hap: 0.07, sap: 'groen' },
    { sprite: 'aril4', breedte: 28, tol: 220, hoek0: 330, r: 1.0, dy: 2, hap: 0.04, sap: 'rood' }
  ];

  // Het water: geen ding en geen stroom op de baan (water vliegt niet in een
  // kring; dat las als een glazen staaf), maar wat water doet: het wordt erbij
  // geschonken. Een dunne straal valt van buiten beeld, rechtsboven, in een
  // worp de mond in zolang de ingrediënten erin duiken. Onderweg versnelt hij
  // en wordt hij dunner; aan het eind breekt hij in druppels. De tube vult
  // gestaag zolang hij stroomt.
  var WATER = {
    giet: 2.05,     // de kop van de straal komt het beeld in
    duur: 1.85,     // zo lang wordt er geschonken
    val: 0.25,      // in zo veel seconden valt het water van boven het beeld tot diep in de tube
    van: [62, 16],  // waar hij vandaan komt: zo ver rechts van de mond, zo ver boven de bovenrand van het vlak (wm)
    vlak: 0.25,     // 0 = hij komt horizontaal aan en valt in een wijde boog, 0.5 = een rechte lijn
    dik: 5.6,       // halve dikte (wm) bovenaan; onderaan is hij door zijn vaart dunner
    vaag: 12,       // onder de bovenrand van het beeld loopt hij over zo veel wm uit in het papier (hij komt van buiten beeld)
    diep: 34,       // zo ver zakt de straal de tube in (onder de rand is hij weg)
    hap: 0.31,      // zijn aandeel in de bolling van de tube
    druppels: 7     // losse druppels na de staart
  };

  // De duik: eerst de sprong (een boog van de baan naar een punt recht boven
  // de mond, waar hij even hangt), dan de plons (recht omlaag de tube in).
  var DUIK = {
    sprong: 0.42,   // duur van de sprong
    plons: 0.24,    // duur van de plons
    boog: 18,       // zo veel hoger dan het hangpunt mikt de boog
    zweef: 18,      // omtrekstraal (wm) waarmee hij boven de mond hangt: grote stukjes krimpen hiernaar, zodat het groepje boven de mond niet breder is dan de mond
    lucht: 6,       // ruimte tussen zijn onderkant en de rand van de mond op het hangpunt
    smal: 0.8,      // bij de rand hooguit dit deel van de mond breed
    rek: 0.2,       // en zo veel langer (hij wordt naar binnen gezogen)
    klein: 0.3,     // zo veel kleiner aan het eind van de plons
    slik: 0.55,     // op dit deel van de plons slikt de tube
    helder: [0, 0.2]     // wie van achter komt wordt tussen deze delen van de sprong helder (de gloed van de svg gaat van hem af); klaar voordat hij bij de anderen boven de mond is, anders zie je ze door hem heen
  };

  // De hap: wat de tube doet als er iets in valt.
  var HAP = {
    zwel: 0.34,              // duur van het boller worden
    ease: 'back.out(2.6)',   // met een schokje erdoorheen
    golf: 0.36,              // duur van de golf van de naad naar de dop
    golfMaat: 0.2,           // hoogte van de golf (deel van de breedte) bij hap 1; kleinere happen kleiner
    golfBreed: 0.13,         // breedte van de golf (deel van de lengte)
    schok: 0.4,              // duur van de schok
    krimp: 0.055,            // zo veel korter veert de tube in bij de schok (deel van de lengte)
    spat: 0.4                // levensduur van een spatje sap
  };

  // De tube (wm). as, top, voet en mond beschrijven de foto; bol is de
  // overdrijving.
  var TUBE = {
    as: 524.3,      // de middellijn van de tube in de foto
    top: 0,         // de naad (de mond)
    voet: 130,      // waar hij op zijn dop staat
    mond: 22,       // halve breedte van de naad
    bol: 1.18,      // op bol 1 is de buik 1 + bol keer zo breed
    kap: 0.875,     // vanaf dit deel van de lengte begint de dop: die blijft stijf
    lang: 0.045,    // op bol 1 zo veel langer
    duw: 6,         // zo ver schuiven de k en de y extra opzij op bol 1 (bij 7 staat de y op een telefoon op 1,5 px van de rand)
    rest: 1,        // en zo veel schuift 'Fran' met de k mee (1 = evenveel; minder dan 0,85 en de k raakt de n)
    spleet: 10      // de k en de y staan in de beginstand al zo ver uit elkaar
  };

  // Overdreven vol: de tube trilt van de spanning.
  var VOL = {
    op: 0.18,       // in zo veel seconden komt het trillen op
    hz: 17,         // trillingen per seconde
    bol: 0.04,      // de bolling ademt zo veel mee
    zwaai: 0.9      // en de naad zwaait zo veel wm heen en weer
  };

  // De glans en de schaduw op de bolle tube (source-atop, dus alleen op de
  // tube zelf). Licht van linksboven, net als de slagschaduw. 'rand' is een
  // smalle donkere zoom langs de zijkanten: de foto heeft daar een lichte
  // uitsnijrand, die bij het oprekken breder wordt en tegen de gloed afsteekt.
  var GLANS = { licht: 0.78, donker: 0.46, rand: 0.42 };

  // De zachte schaduw onder een vliegende sprite, in delen van zijn breedte.
  var SCHADUW = { dx: 0.035, dy: 0.085, sigma: 0.045, dekking: 0.22 };

  // De slagschaduw van de tubefoto in de svg (feDropShadow, wm).
  var SLAG = { dx: 0.6, dy: 1.2, sigma: 0.9, kleur: 'rgba(35,16,24,0.16)' };

  var MERK = {
    teal: '#00A19C', tealBleek: '#7FD1C7', mint: '#96E2C0', berry: '#83245F',
    roze: '#E89CDB', zand: '#D9C9AE', taupe: '#8A7A5E'
  };
  var INKT = '#231018';
  // De spatten: een druppel van licht (waar het licht erdoor valt) naar donker.
  var SPAT = {
    rood: ['rgba(238,120,150,0.85)', 'rgba(190,22,66,0.95)', 'rgba(104,6,36,0.98)'],
    groen: ['rgba(222,240,196,0.8)', 'rgba(150,198,108,0.92)', 'rgba(78,126,52,0.96)'],
    wit: ['rgba(255,255,255,0.95)', 'rgba(240,234,224,0.95)', 'rgba(176,160,140,0.95)'],
    water: ['rgba(215,236,244,0.34)', 'rgba(150,200,220,0.4)', 'rgba(30,80,108,0.72)']
  };

  // De maat van de sprite-sheet waarop de vakken hieronder gemeten zijn.
  // Levert het CDN de sheet op een andere maat, dan rekent het script om;
  // een sheet met een andere verhouding hoort niet bij deze vakken en wordt
  // niet gebruikt (dan speelt de rustige variant).
  var SHEET_B = 832;
  var SHEET_H = 586;

  // De vakken van de sprite-sheet (assets, 832 x 586 px; uit de bouw van de
  // sheet): x, y, b, h in px, het zwaartepunt (deel van b en h) waar de sprite
  // om tolt, en de straal van de inhoud om dat punt (deel van b).
  var VAKKEN = {
    aril1: [2, 422, 153, 115, 0.5101, 0.4867, 0.508],
    aril2: [159, 426, 120, 131, 0.4734, 0.4785, 0.602],
    aril3: [283, 440, 107, 144, 0.5077, 0.4768, 0.693],
    aril4: [215, 293, 125, 129, 0.4538, 0.5196, 0.589],
    aril5: [394, 440, 152, 101, 0.4665, 0.4785, 0.531],
    aloe: [2, 2, 350, 287, 0.4635, 0.5058, 0.536],
    kokos1: [356, 2, 280, 231, 0.5588, 0.5149, 0.610],
    kokos2: [356, 237, 215, 199, 0.4758, 0.5310, 0.567],
    kokos3: [575, 253, 190, 203, 0.5081, 0.3971, 0.651],
    kokos4: [2, 293, 209, 125, 0.4535, 0.4624, 0.563],
    schijf1: [698, 460, 124, 90, 0.5854, 0.6448, 0.594],
    schijf2: [550, 460, 144, 78, 0.5578, 0.3360, 0.554],
    druppel1: [640, 2, 190, 247, 0.5007, 0.5421, 0.777]
  };

  // De halve breedte van de tube in de foto (wm) langs zijn lengte (0 = naad,
  // 1 = voet), gemeten aan de foto. Alleen voor de plek van de glans.
  var TUBE_HALF = [[0, 22.9], [0.08, 21.8], [0.26, 19.1], [0.48, 16.9], [0.75, 14.7], [0.89, 13.3], [0.94, 13.2], [0.98, 11.5], [1, 6]];

  var RAD = Math.PI / 180;
  var TWEE_PI = Math.PI * 2;
  // Tot zo ver van het midden staan letters, ook als de volle tube de k en de
  // y opzij duwt: daarbuiten wisselt een rol van laag.
  var WOORD = BAAN.woord + TUBE.spleet + TUBE.duw;

  function klem(x) {
    return x < 0 ? 0 : x > 1 ? 1 : x;
  }
  // Zacht van 0 naar 1 (smoothstep).
  function glad(x) {
    x = klem(x);
    return x * x * (3 - 2 * x);
  }
  // Een vast 'toevalsgetal' per paar getallen, zodat het elke keer hetzelfde is.
  function hash(x, y) {
    var h = Math.sin(x * 12.9898 + y * 78.233) * 43758.5453;
    return h - Math.floor(h);
  }
  function maakDoek(b, h) {
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(b));
    c.height = Math.max(1, Math.round(h));
    return c;
  }
  // Geeft het geheugen van een hulpdoek meteen terug (Safari op een telefoon
  // heeft een krap plafond voor alle canvassen samen en ruimt zelf traag op).
  function geefVrij(c) {
    if (c && c.getContext) {
      c.width = 0;
      c.height = 0;
    }
  }

  function start(hero) {
    if (!hero || hero.hasAttribute('data-frankly-baan-actief')) return;
    hero.setAttribute('data-frankly-baan-actief', '');

    // Verminder beweging (prefers-reduced-motion) slaat de hero niet over: dan
    // speelt rustigSpelen() hieronder, met alleen overvloeiers.
    var rustig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!window.gsap || !window.DrawSVGPlugin || !window.MorphSVGPlugin) {
      hero.classList.remove('is-wacht');
      return;
    }
    var gsap = window.gsap;
    gsap.registerPlugin(window.DrawSVGPlugin, window.MorphSVGPlugin);

    function alles(sel) {
      return Array.prototype.slice.call(hero.querySelectorAll(sel));
    }
    function een(sel) {
      return hero.querySelector(sel);
    }

    var vraag = new URLSearchParams(window.location.search);
    var debug = vraag.get('fh_debug');

    /* ---- Elementen ----------------------------------------------------- */
    var svg = een('.fh-scene');
    var vak = een('.fh-frankly');
    if (!svg || !vak || !document.createElement('canvas').getContext) {
      hero.classList.remove('is-wacht');
      return;
    }
    var excl = een('.fh-scene__excl');
    var buik = een('.fh-tube__buik');
    var tubeFoto = een('.fh-tube__foto');
    var naad = een('.fh-tube__naad');
    var lijf = een('.fh-tube__lijf');
    var dop = een('.fh-tube__dop');
    var letterK = een('.fh-scene__k');
    var letterY = een('.fh-scene__y');
    var grond = een('.fh-scene__letters');
    var fran = alles('.fh-letter-pad--F, .fh-letter-pad--r, .fh-letter-pad--a, .fh-letter-pad--n');
    var claims = alles('.fh-hero__claim');
    var letters = alles('.fh-letter');
    var kopje = een('.fh-hero2__kopje');
    var lucht = een('.fh-lucht');
    var gloed = een('.fh-gloed');

    /* ---- De rollen: tijden die uit de regie volgen ----------------------- */
    var M0 = TIJD.morph;
    var OMEGA = TWEE_PI / OMLOOP;         // rad per seconde
    // Vangnet: een rol met een sprite die niet in VAKKEN staat doet niet mee
    // (anders breekt één tikfout de hele timeline). De rest schuift op: de
    // stroom houdt geen gat.
    // Hero 'geel' (19-10-2026): de halve granaatappel en het aloëplantje draaien mee
    // en duiken ook de tube in (Max: 'alleen dynamisch, niet still'). Hun vakken
    // staan alleen in de getekende sheet (op de plek van kokos1 en kokos2).
    var rolLijst = ROLLEN;
    if (hero.classList.contains('fh-hero2--geel')) {
      VAKKEN.granaat = [356, 2, 280, 231, 0.5, 0.52, 0.62];
      VAKKEN.aloeplant = [356, 237, 215, 199, 0.5, 0.55, 0.6];
      rolLijst = ROLLEN.concat([
        { sprite: 'granaat', breedte: 56, tol: 70, hoek0: 20, r: 1.02, dy: -10, hap: 0.08, sap: 'rood' },
        { sprite: 'aloeplant', breedte: 50, tol: -60, hoek0: 300, r: 0.98, dy: 6, hap: 0.08, sap: 'groen' }
      ]);
    }
    var geldig = rolLijst.filter(function (r) {
      return r && VAKKEN[r.sprite] && r.breedte > 0;
    });
    var hapSom = 0;
    geldig.forEach(function (r) { hapSom += r.hap || 0; });
    hapSom += WATER.hap;
    // De ring (zie STROOM). Plek k staat op 'start' k stappen achter het
    // vertrekpunt achterlangs. Hij bereikt dat punt na k stappen, en het punt
    // voorlangs na de hoek tussen de twee punten plus k stappen (een ronde
    // verder telt als nul). Hij duikt waar hij het eerst is. Op volgorde van
    // duiken zijn dat de beurten; rol i krijgt beurt i.
    var stap = TWEE_PI / Math.max(1, geldig.length);
    var naarVoor = (STROOM.voor - BAAN.vertrek) * RAD;
    naarVoor = Math.round((naarVoor - stap / 2) / stap) * stap + stap / 2;
    var beurten = geldig.map(function (r, k) {
      var achter = k * stap;
      var voor = (((naarVoor + k * stap) % TWEE_PI) + TWEE_PI) % TWEE_PI;
      return achter <= voor ? { na: achter / OMEGA, kant: 'achter' } : { na: voor / OMEGA, kant: 'voor' };
    }).sort(function (a, b) { return a.na - b.na; });
    var rollen = geldig.map(function (r, i) {
      var vak7 = VAKKEN[r.sprite];
      // Zijn beurt in de stroom, en de kant waar hij de baan verlaat: daaruit
      // volgt zijn plek op de baan (hij komt op zijn duikmoment net langs het
      // vertrekpunt van zijn kant).
      var duik = typeof r.duik === 'number' && isFinite(r.duik) ? r.duik : STROOM.start + beurten[i].na;
      var kant = r.kant || beurten[i].kant;
      var fase = r.fase !== undefined ? r.fase * RAD : BAAN.vertrek * RAD + (kant === 'voor' ? naarVoor : 0) - OMEGA * duik;
      var tIn = r['in'] !== undefined ? r['in'] : TIJD.intocht + i * INTOCHT.na;
      // De intocht en de laagwissel (zie INTOCHT): na 'totKruis' seconden
      // passeert de rol voor het eerst een uiteinde van de baan.
      var hoekIn = fase + OMEGA * tIn;
      var totKruis = Infinity;
      if (OMEGA > 0) totKruis = ((Math.floor(hoekIn / Math.PI + 1e-9) + 1) * Math.PI - hoekIn) / OMEGA;
      else if (OMEGA < 0) totKruis = ((Math.ceil(hoekIn / Math.PI - 1e-9) - 1) * Math.PI - hoekIn) / OMEGA;
      var inDuur = INTOCHT.duur;
      var inLaag = 0;                      // 1 = tot tKruis op de voorste laag, -1 = op de achterste, 0 = volgt de baan
      if (totKruis < INTOCHT.duur) {
        if (totKruis >= INTOCHT.duur * INTOCHT.vroeg) {
          inDuur = totKruis;
        } else {
          inLaag = Math.sin(hoekIn + OMEGA * (totKruis + 0.01)) >= 0 ? 1 : -1;
          inDuur = Math.min(INTOCHT.duur, totKruis + Math.PI / Math.abs(OMEGA));
        }
      }
      return {
        nr: i,
        sprite: r.sprite,
        breedte: r.breedte,
        fase: fase,
        tIn: tIn,
        inDuur: inDuur,
        inLaag: inLaag,
        tKruis: tIn + totKruis,
        duik: duik,
        tPlons: duik + DUIK.sprong,
        tSlik: duik + DUIK.sprong + DUIK.plons * DUIK.slik,
        tWeg: duik + DUIK.sprong + DUIK.plons,
        tol: (r.tol || 0) * RAD,
        hoek0: (r.hoek0 || 0) * RAD,
        r: r.r || 1,
        dy: r.dy || 0,
        spiegel: r.spiegel || 1,
        hap: hapSom > 0 ? (r.hap || 0) / hapSom : 0,
        spat: SPAT[r.sap] || SPAT.rood,
        straal: vak7 ? vak7[6] : 0.6   // omtrekstraal, deel van de breedte
      };
    });
    var T_DUIK = Infinity;
    var T_VOL = 0;
    var T_PLONS = Infinity;
    var T_SLIK = Infinity;
    var T_IN = Infinity;      // de eerste rol komt het beeld in
    var T_UIT = 0;            // de laatste rol is de tube in
    rollen.forEach(function (r) {
      T_DUIK = Math.min(T_DUIK, r.duik);
      T_PLONS = Math.min(T_PLONS, r.tPlons);
      T_SLIK = Math.min(T_SLIK, r.tSlik);
      T_VOL = Math.max(T_VOL, r.tSlik + 0.12);
      T_IN = Math.min(T_IN, r.tIn);
      T_UIT = Math.max(T_UIT, r.tWeg);
    });
    /* ---- Het water: tijden die uit de regie volgen ------------------------ */
    // Water dat op moment T het beeld in komt, is WATER.val later diep in de
    // tube; op ongeveer 0,8 daarvan passeert het de rand van de mond. De kop
    // komt op WATER.giet, de staart WATER.duur later, en daarna nog wat losse
    // druppels. Deze tijden hangen niet van de maat van het vlak af.
    var W_T0 = WATER.giet + WATER.val * 0.8;                 // de kop raakt de mond: de tube begint te vullen
    var W_T1 = WATER.giet + WATER.duur + WATER.val * 0.8;    // de staart is erin
    var W_EIND = WATER.giet + WATER.duur + WATER.val + 0.3;  // de laatste druppel ook
    var W_HAP = hapSom > 0 ? WATER.hap / hapSom : 0;
    // Zonder één geldige rol blijft alleen het water over: de tijden hieronder
    // houden dan de labels en de morph op hun plek.
    T_IN = Math.min(T_IN, WATER.giet);
    T_UIT = Math.max(T_UIT, W_EIND);
    T_VOL = Math.max(T_VOL, W_T1);
    T_PLONS = Math.min(T_PLONS, W_T0);
    T_SLIK = Math.min(T_SLIK, W_T0);
    T_DUIK = Math.min(T_DUIK, WATER.giet);
    // De morph wacht op de laatste hap: de tube staat eerst TIJD.vol vol.
    M0 = Math.max(M0, T_VOL + TIJD.vol);

    // De wissel van SVG-foto naar canvas: precies op de eerste slik (het
    // water dat de mond raakt, of anders de eerste hap). Op dat
    // moment is de tube nog onaangeroerd (bol 0: in Chrome tot op de pixel
    // gelijk aan de foto) en in het beeld erna beweegt hij al. Safari tekent
    // de SVG-foto door het filter een fractie zachter dan het canvas; doordat
    // de wissel samenvalt met de schok is dat niet te zien.
    var T_WISSEL = debug === 'tube' ? 0.001 : T_SLIK;
    // Hierna staat er niets meer op de canvassen (de foto is weg na de poef).
    var T_LEEG = M0 + 0.36;
    // De pluim die uit de mond spuit als de k en de y de tube leegknijpen.
    var T_PUF = M0 + 0.12;

    var zwelEase = gsap.parseEase(HAP.ease);
    var uitEase = gsap.parseEase('power3.out');

    /* ---- Beginstand ------------------------------------------------------ */
    // De markup is de eindstand (Frank!y). Hier: de tube terug, het teken weg.
    // De akker van de vorige hero (vrucht, blad, schetslijnen, zuiggat) staat
    // nog in de markup op visibility hidden en blijft dat.
    var lijfEind = lijf.getAttribute('d');
    var dopEind = dop.getAttribute('d');
    lijf.setAttribute('d', lijf.getAttribute('data-begin'));
    dop.setAttribute('d', dop.getAttribute('data-begin'));
    gsap.set(excl, { svgOrigin: '524.44 130' });
    gsap.set(buik, { svgOrigin: '524.44 130' });
    gsap.set([lijf, dop], { opacity: 0 });
    gsap.set(dop, { transformOrigin: '50% 50%' });
    gsap.set(naad, { opacity: 0 });
    gsap.set(claims, { opacity: 0, y: 6 });
    gsap.set(letters, { opacity: 0 });
    if (kopje) gsap.set(kopje, { opacity: 0 });
    if (lucht) gsap.set(lucht, { opacity: 0 });
    if (gloed) gsap.set(gloed, { opacity: 0 });

    // Wat de timeline aan de tube stuurt. De rest van zijn stand (bol, golf,
    // schok) rekent tubeStand(t) uit de happen; teken(t) zet er de foto, de k
    // en de y mee.
    //   doek    1 = de tube staat op het canvas, de SVG-foto is uit
    //   foto    dekking van de foto (dooft bij de poef)
    //   naad    de naad flitst vlak voor de poef
    //   spleet  1 = de k en de y staan TUBE.spleet uit elkaar, 0 = dicht
    //   leeg    1 = alle bolling eruit geknepen
    //   tril    sterkte van het trillen
    var tube = { doek: 0, foto: 1, naad: 0, spleet: 1, leeg: 0, tril: 0 };

    // De k en de y: TUBE.spleet uit elkaar in de beginstand, verder naarmate de
    // tube boller wordt, dicht bij de morph. 'Fran' schuift met de k mee, anders
    // botst de k op de n. teken() beheert deze transforms.
    var kyLaatst = '';
    var franLaatst = '';
    function zetLetters(spleet, bol) {
      var x = (TUBE.spleet * spleet + TUBE.duw * bol).toFixed(2);
      if (x !== kyLaatst) {
        kyLaatst = x;
        letterK.setAttribute('transform', 'translate(' + (-x) + ' 0)');
        letterY.setAttribute('transform', 'translate(' + x + ' 0)');
      }
      var f = (TUBE.duw * TUBE.rest * bol).toFixed(2);
      if (f !== franLaatst) {
        franLaatst = f;
        for (var i = 0; i < fran.length; i++) {
          if (f === '0.00') fran[i].removeAttribute('transform');
          else fran[i].setAttribute('transform', 'translate(' + (-f) + ' 0)');
        }
      }
    }
    // De SVG-foto: te zien zolang de tube niet op het canvas staat.
    var fotoLaatst = '';
    function zetFoto(zichtbaar, dekking) {
      var s = (zichtbaar && dekking > 0.001 ? 'v' : 'h') + dekking.toFixed(3);
      if (s === fotoLaatst) return;
      fotoLaatst = s;
      tubeFoto.style.visibility = s.charAt(0) === 'v' ? 'visible' : 'hidden';
      tubeFoto.style.opacity = dekking.toFixed(3);
    }
    // Met 'Verminder beweging' staan de k en de y meteen op hun plek (zie
    // assets/frankly-akker.css): dan verspringt er bij het starten niets.
    zetLetters(rustig ? 0 : 1, 0);
    zetFoto(true, 1);

    /* ======================================================================
       G. TIMELINE — labels, wat in de SVG beweegt, en de morph.
       ====================================================================== */
    var tl = gsap.timeline({ paused: true, defaults: { ease: 'power2.out' } });
    tl.addLabel('stil', 0)
      .addLabel('intocht', TIJD.intocht)
      .addLabel('baan', TIJD.baan)
      .addLabel('duik', T_DUIK)
      .addLabel('vol', T_VOL)
      .addLabel('morph', M0)
      .addLabel('claims', M0 + 0.7)
      .addLabel('letters', M0 + 1.3);

    if (kopje) tl.to(kopje, { opacity: 1, duration: 0.3, ease: 'none' }, 0.2);

    // De groene gloed (de lucht achter het woord en de gloed om de tube) is
    // er op verzoek van de eigenaar uit (04-10). De sectie zet die vormen niet
    // meer voor dit tussenstuk; staan ze er toch (oude markup), dan blijven ze
    // uit: zie de beginstand hierboven.

    // De tube gaat naar het canvas; overdreven vol trilt hij.
    tl.set(tube, { doek: 1 }, T_WISSEL);
    tl.to(tube, { tril: 1, duration: VOL.op, ease: 'power1.out' }, T_VOL);
    tl.to(tube, { tril: 0, duration: 0.12, ease: 'none' }, Math.max(M0 + 0.06, T_VOL + VOL.op));

    // Morph: naad, de k en de y knijpen de tube leeg, poef, lijf en dop worden
    // het teken.
    tl.set(tube, { naad: 1 }, M0 + 0.04);
    tl.set(tube, { naad: 0 }, M0 + 0.08);
    tl.set(tube, { naad: 1 }, M0 + 0.12);
    tl.to(tube, { leeg: 1, duration: 0.2, ease: 'power2.in' }, M0 + 0.08);
    tl.to(tube, { spleet: 0, duration: 0.2, ease: 'back.out(1.7)' }, M0 + 0.1);
    tl.to(excl, { scaleX: 0.86, scaleY: 1.06, duration: 0.1, ease: 'power2.in' }, M0 + 0.25);
    tl.to(tube, { foto: 0, duration: 0.05, ease: 'none' }, M0 + 0.3);
    tl.to(tube, { naad: 0, duration: 0.05, ease: 'none' }, M0 + 0.3);
    tl.to([lijf, dop], { opacity: 1, duration: 0.05, ease: 'none' }, M0 + 0.3);
    tl.to(excl, { scaleX: 1.07, scaleY: 0.96, duration: 0.1, ease: 'power2.out' }, M0 + 0.35);
    tl.to(excl, { scaleX: 1, scaleY: 1, duration: 0.1, ease: 'power1.inOut' }, M0 + 0.45);
    tl.to(lijf, { morphSVG: lijfEind, duration: 0.35, ease: 'power2.out' }, M0 + 0.35);
    tl.to(dop, { morphSVG: dopEind, duration: 0.28, ease: 'power2.out' }, M0 + 0.4);
    tl.to(dop, { y: -58, rotation: 200, duration: 0.24, ease: 'power2.out' }, M0 + 0.4);
    tl.to(dop, { y: 0, rotation: 360, duration: 0.21, ease: 'power2.in' }, M0 + 0.64);
    tl.to(dop, { y: -8, duration: 0.05, ease: 'power1.out' }, M0 + 0.85);
    tl.to(dop, { y: 0, duration: 0.05, ease: 'power1.in' }, M0 + 0.9);
    tl.to(excl, { scaleX: 1.05, scaleY: 0.93, duration: 0.07, ease: 'power1.out' }, M0 + 0.85);
    tl.to(excl, { scaleX: 0.98, scaleY: 1.02, duration: 0.09, ease: 'power1.inOut' }, M0 + 0.92);
    tl.to(excl, { scaleX: 1, scaleY: 1, duration: 0.09, ease: 'power1.inOut' }, M0 + 1.01);

    // Claims vanaf M0 + 0,7, 250 ms na elkaar; onderschrift vanaf M0 + 1,3.
    tl.to(claims, { opacity: 1, y: 0, duration: 0.26, ease: 'power3.out', stagger: 0.25 }, M0 + 0.7);
    tl.to(letters, { opacity: 1, duration: 0.14, ease: 'none', stagger: 0.022 }, M0 + 1.3);

    hero.classList.add('is-gsap');

    /* ======================================================================
       A. LAGEN — twee canvassen die precies over het scènevlak liggen.
       'achter' staat in de DOM vóór de svg (dus eronder), 'voor' erna (z-index
       1, erboven). Ze vangen geen klikken en hebben geen masker. Op desktop
       knipt .fh-frankly de bovenste strook weg (clip-path): de lagen zijn
       kinderen van dat vak en gaan daarin mee.
       ====================================================================== */
    function maakLaag(klasse, boven) {
      var oud = vak.querySelector('.' + klasse);
      if (oud) oud.parentNode.removeChild(oud);
      var c = document.createElement('canvas');
      c.className = klasse;
      c.setAttribute('aria-hidden', 'true');
      c.style.position = 'absolute';
      c.style.display = 'block';
      c.style.left = '0';
      c.style.top = '0';
      c.style.margin = '0';
      c.style.maxWidth = 'none';
      c.style.pointerEvents = 'none';
      if (boven) {
        c.style.zIndex = '1';
        vak.appendChild(c);
      } else {
        vak.insertBefore(c, svg);
      }
      return c;
    }
    var oudDoek = een('.fh-atomen');
    if (oudDoek) oudDoek.style.display = 'none';
    var achter = maakLaag('fh-baan-achter', false);
    var voor = maakLaag('fh-baan-voor', true);
    var penA = achter.getContext('2d');
    var penV = voor.getContext('2d');

    var dpr = 1;
    var GEO = null;       // alles wat van de maat van het vlak afhangt (bouw)
    var sleutel = '';     // de maat waarvoor GEO gebouwd is
    var vuil = false;     // staat er iets op de canvassen?

    // Meet waar de lagen moeten liggen. De svg staat niet altijd op een hele
    // pixel (desktop: 69,31 px van boven). Browsers tekenen de svg dan vanaf de
    // dichtstbijzijnde hele scherm-px, maar een canvas leggen ze elk anders
    // neer: Chrome op hele scherm-px, Safari op hele CSS-px (plek én maat; een
    // laag van 162,5 px hoog rekt Safari uit tot 163). Gemeten in WebKit lag de
    // tube op het canvas daardoor tot een halve px naast de SVG-foto. Daarom
    // ligt de laag zelf altijd op het raster dat beide browsers heel laten
    // (hele CSS-px bij een hele schermdichtheid, anders hele scherm-px), links
    // boven de svg, en schuift de tekening binnen de laag (dx, dy) naar waar
    // de svg echt getekend wordt. Alles ten opzichte van het document: zo
    // ronden de browsers ook af.
    function meetVlak() {
      var fr = vak.getBoundingClientRect();
      var sr = svg.getBoundingClientRect();
      var echt = window.devicePixelRatio || 1;
      var heel = Math.abs(echt - Math.round(echt)) < 0.001;
      var stap = heel ? 1 : 1 / echt;
      var sx = window.pageXOffset || 0;
      var sy = window.pageYOffset || 0;
      var links = Math.floor((sr.left + sx) / stap + 0.001) * stap - sx;
      var boven = Math.floor((sr.top + sy) / stap + 0.001) * stap - sy;
      return {
        sr: sr,
        heel: heel,
        links: links - fr.left,               // plek van de laag binnen .fh-frankly (CSS-px)
        boven: boven - fr.top,
        b: sr.right - links,                  // zo veel moet de laag beslaan (CSS-px)
        h: sr.bottom - boven,
        dx: Math.round((sr.left + sx) * echt) / echt - sx - links,   // van de hoek van de laag naar de hoek van de getekende svg
        dy: Math.round((sr.top + sy) * echt) / echt - sy - boven
      };
    }

    // Zet plaats en maat van de lagen (m = meetVlak()). De bitmap is de maat
    // van het vlak maal dpr (hooguit 2), naar boven afgerond; de CSS-maat is de
    // bitmap gedeeld door dpr, zodat één bitmap-px precies één scherm-px is
    // (geen herschaling, dus geen waas).
    //   'nieuw'  een nieuwe bitmap op de maat van nu (wist de laag)
    //   'rek'    tijdens het slepen aan het venster: de oude bitmap rekt mee
    //            met de svg tot bouw() hem ververst
    //   'vast'   de CSS-maat terug op de bitmap (na 'rek', als de maat
    //            uiteindelijk gelijk bleef)
    function plaatsLagen(hoe, m) {
      if (!m) m = meetVlak();
      [achter, voor].forEach(function (c) {
        c.style.left = m.links + 'px';
        c.style.top = m.boven + 'px';
        if (hoe === 'rek') {
          // Alleen meerekken als de maat echt veranderd is (de bitmap is
          // hooguit één px ruimer dan het vlak): op een telefoon vuurt resize
          // bij elke beweging van de adresbalk.
          var ruimB = c.width / dpr - m.b;
          var ruimH = c.height / dpr - m.h;
          if (ruimB < -0.01 || ruimB >= 1 || ruimH < -0.01 || ruimH >= 1) {
            c.style.width = m.b + 'px';
            c.style.height = m.h + 'px';
            return;
          }
        }
        if (hoe === 'nieuw') {
          c.width = Math.max(1, Math.ceil((m.heel ? Math.ceil(m.b - 0.01) : m.b) * dpr - 0.01));
          c.height = Math.max(1, Math.ceil((m.heel ? Math.ceil(m.h - 0.01) : m.h) * dpr - 0.01));
        }
        c.style.width = (c.width / dpr) + 'px';
        c.style.height = (c.height / dpr) + 'px';
      });
    }

    function wis() {
      penA.setTransform(1, 0, 0, 1, 0, 0);
      penA.clearRect(0, 0, achter.width, achter.height);
      penV.setTransform(1, 0, 0, 1, 0, 0);
      penV.clearRect(0, 0, voor.width, voor.height);
      vuil = false;
    }

    // Staat er niets op, dan zijn de lagen er helemaal niet (display none): de
    // begin- en de eindstand zijn zo tot op de pixel die van de svg alleen. Een
    // leeg canvas onder de svg laat de browser de svg anders samenstellen (de
    // gloed en de randen wijken dan een tint af).
    var lagenAan = true;
    function toonLagen(aan) {
      if (aan === lagenAan) return;
      lagenAan = aan;
      achter.style.display = aan ? 'block' : 'none';
      voor.style.display = aan ? 'block' : 'none';
    }
    toonLagen(false);

    // Van wm naar bitmap-px.
    function zetWm(pen) {
      pen.setTransform(GEO.kx, 0, 0, GEO.ky, GEO.tx, GEO.ty);
    }

    /* ======================================================================
       B. SPRITES — de sheet wordt per sprite één keer gebakken op de grootste
       maat waarop hij getekend wordt: het beeld (in stappen van hooguit de
       helft verkleind, dat blijft in elke browser scherp) en los daarvan zijn
       zachte schaduw (shadowBlur, alleen hier). Per frame is het daarna alleen
       nog drawImage. Er wordt nergens een pixel teruggelezen.
       ====================================================================== */
    var sheet = null;     // het geladen plaatje
    var tubeBeeld = null;

    // Verkleint een vak van de bron in stappen naar b x h px.
    function verklein(bron, sx, sy, sb, sh, b, h, rand) {
      var nu = bron;
      var nx = sx;
      var ny = sy;
      var nb = sb;
      var nh = sh;
      while (nb / 2 >= b && nh / 2 >= h) {
        var tb = Math.ceil(nb / 2);
        var th = Math.ceil(nh / 2);
        var tussen = maakDoek(tb, th);
        var tp = tussen.getContext('2d');
        tp.imageSmoothingEnabled = true;
        tp.imageSmoothingQuality = 'high';
        tp.drawImage(nu, nx, ny, nb, nh, 0, 0, tb, th);
        if (nu !== bron) geefVrij(nu);
        nu = tussen;
        nx = 0;
        ny = 0;
        nb = tb;
        nh = th;
      }
      var uit = maakDoek(b + 2 * rand, h + 2 * rand);
      var p = uit.getContext('2d');
      p.imageSmoothingEnabled = true;
      p.imageSmoothingQuality = 'high';
      p.drawImage(nu, nx, ny, nb, nh, rand, rand, b, h);
      if (nu !== bron) geefVrij(nu);
      return uit;
    }

    function bakSprites(k, maat) {
      var bak = {};
      // De grootste breedte (wm) waarop elke sprite voorkomt.
      var grootst = {};
      rollen.forEach(function (r) {
        var w = r.breedte * maat * (1 + BAAN.diep);
        if (!(grootst[r.sprite] > w)) grootst[r.sprite] = w;
      });
      Object.keys(grootst).forEach(function (naam) {
        var v = VAKKEN[naam];
        if (!v) return;
        var b = Math.min(v[2], Math.max(8, Math.ceil(grootst[naam] * k)));
        var h = Math.max(1, Math.round(b * v[3] / v[2]));
        var rand = 2;
        var sf = sheet.naturalWidth / SHEET_B;
        var beeld = verklein(sheet, v[0] * sf, v[1] * sf, v[2] * sf, v[3] * sf, b, h, rand);
        // De schaduw: alleen de vervaagde omtrek, in inkt. De sprite zelf
        // wordt buiten het doek getekend; alleen zijn schaduw valt erop.
        var sigma = Math.max(0.5, SCHADUW.sigma * b);
        var zoom = Math.ceil(sigma * 3) + 2;
        var sch = maakDoek(b + 2 * zoom, h + 2 * zoom);
        var sp = sch.getContext('2d');
        var ver = sch.width + beeld.width + 20;
        sp.shadowColor = INKT;
        sp.shadowBlur = sigma * 2;
        sp.shadowOffsetX = ver;
        sp.shadowOffsetY = 0;
        sp.drawImage(beeld, zoom - rand - ver, zoom - rand);
        bak[naam] = {
          beeld: beeld, schaduw: sch, b: b, h: h, rand: rand, zoom: zoom,
          zx: v[4] * b, zy: v[5] * h
        };
      });
      return bak;
    }

    // Tekent één sprite. x, y en breedte in wm; hoek in radialen. Opties:
    //   dekking  0..1
    //   spiegel  -1 = gespiegeld
    //   px, py   platdrukken langs de schermassen (px 0,5 = half zo breed),
    //            na het draaien: zo wordt hij smal als hij de tube in gaat
    //   schaduw  0..1, sterkte van de zachte schaduw eronder (0 = geen)
    function tekenSprite(pen, naam, x, y, breedte, hoek, o) {
      var s = GEO.sprites[naam];
      if (!s) return;
      var f = breedte / s.b;                  // wm per gebakken px
      var px = o && o.px !== undefined ? o.px : 1;
      var py = o && o.py !== undefined ? o.py : 1;
      var spiegel = o && o.spiegel === -1 ? -1 : 1;
      var dekking = o && o.dekking !== undefined ? o.dekking : 1;
      var schaduw = o && o.schaduw !== undefined ? o.schaduw : 1;
      if (dekking <= 0.004) return;
      if (schaduw > 0.004) {
        zetWm(pen);
        pen.translate(x + SCHADUW.dx * breedte, y + SCHADUW.dy * breedte);
        pen.scale(px, py);
        pen.rotate(hoek);
        pen.scale(spiegel * f, f);
        pen.globalAlpha = dekking * schaduw * SCHADUW.dekking;
        pen.drawImage(s.schaduw, -s.zx - s.zoom, -s.zy - s.zoom);
      }
      zetWm(pen);
      pen.translate(x, y);
      pen.scale(px, py);
      pen.rotate(hoek);
      pen.scale(spiegel * f, f);
      pen.globalAlpha = dekking;
      pen.drawImage(s.beeld, -s.zx - s.rand, -s.zy - s.rand);
      pen.globalAlpha = 1;
    }

    /* ======================================================================
       C. DE BAAN — een schuine ellips om het woord. baanPunt(hoek, r, uit)
       geeft de plek (wm), de diepte z (-1 = helemaal achter, 1 = helemaal
       voor; vanaf 0 hoort hij op de voorste laag) en de schaal (voor groter).
       De wissel van laag valt dus op hoek 0 en 180: de uiteinden. bouwBaan
       kiest de halve breedte zo dat elke rol daar vrij van de letters en de
       tube staat (op een telefoon is dat buiten beeld), en schuift het midden
       omhoog als de voorkant anders onder het vlak uit zou komen.
       ====================================================================== */
    function bouwBaan(xmin, xmax, cssPerWm, luchtTop) {
      var cx = BAAN.midden[0];
      var half = Math.min(cx - xmin, xmax - cx);
      var maat = Math.max(1, Math.min(BAAN.smalMax, BAAN.smal / cssPerWm));
      var nodig = 0;
      var grootst = 0;
      rollen.forEach(function (r) {
        var R = r.straal * r.breedte * maat;
        nodig = Math.max(nodig, (WOORD + R + 2) / r.r);
        grootst = Math.max(grootst, R * (1 + BAAN.diep) + Math.abs(r.dy));
      });
      var rx = Math.max(nodig, Math.min(BAAN.rx, half - BAAN.rand));
      var ck = Math.cos(BAAN.kantel * RAD);
      var sk = Math.sin(BAAN.kantel * RAD);
      // Hoogste en laagste punt van de schuine ellips liggen 'uit' van het
      // midden. Het vlak is 182,69 - luchtTop hoog; daar moeten de baan en de
      // grootste sprite (voor en achter) in passen. Past BAAN.ry niet, dan
      // wordt de baan lager.
      var achterR = grootst / (1 + BAAN.diep) * (1 - BAAN.diep);
      var ruimte = (182.69 - 2 - luchtTop - grootst - achterR) / 2;
      var ry = BAAN.ry;
      var uit = Math.sqrt(rx * sk * rx * sk + ry * ck * ry * ck);
      if (uit > ruimte) {
        var over = ruimte * ruimte - rx * sk * rx * sk;
        ry = Math.max(24, over > 0 ? Math.sqrt(over) / ck : 24);
        uit = Math.sqrt(rx * sk * rx * sk + ry * ck * ry * ck);
      }
      var cy = BAAN.midden[1];
      cy = Math.min(cy, 182.69 - 2 - uit - grootst);
      cy = Math.max(cy, luchtTop + uit + achterR);
      return { cx: cx, cy: cy, rx: rx, ry: ry, ck: ck, sk: sk, diep: BAAN.diep, maat: maat };
    }

    function baanPunt(hoek, r, uit) {
      var B = GEO.baan;
      var c = Math.cos(hoek);
      var s = Math.sin(hoek);
      var ex = B.rx * r * c;
      var ey = B.ry * r * s;
      uit.x = B.cx + ex * B.ck - ey * B.sk;
      uit.y = B.cy + ex * B.sk + ey * B.ck;
      uit.z = s;
      uit.schaal = 1 + B.diep * s;
      return uit;
    }

    /* ======================================================================
       D. DE TUBE OP HET CANVAS — bakTube tekent de foto één keer op de maat
       van het scherm, met dezelfde slagschaduw als de svg (feDropShadow). Met
       alles op nul (bol 0, geen golf, niet geknepen) zet tekenTube die bak
       ongewijzigd neer: dat valt samen met de SVG-foto (in Chrome tot op de
       pixel, gemeten met tools/verschil op 320 tot 1680 px en dpr 1 en 2; in
       Safari op dezelfde plek, maar daar is de SVG-foto door zijn filter een
       fractie zachter). Anders tekent hij de foto in horizontale stroken van
       één bitmap-px (uit een bron die dubbel zo breed is, zie bakTube), elke
       strook zo breed als tubeBreedte() voorschrijft, op een eigen doek; daar
       komt de glans overheen (source-atop: alleen waar tube is) en dat doek
       gaat in één keer naar de voorste laag. De slagschaduw zit in de bak en
       buigt dus mee. De plek van de foto volgt uit zijn attributen (x, y,
       width, height, xMidYMid meet) en de omrekening van bouw(); de knijp van
       .fh-scene__excl en .fh-tube__buik (schaal om 524,44 130) komt uit
       tubeStand als sx en sy.
       ====================================================================== */
    function bakTube(kx, ky, tx, ty) {
      if (!tubeBeeld || !tubeBeeld.naturalWidth) return null;
      // De foto in de svg: x, y, width, height met xMidYMid meet.
      var fx = parseFloat(tubeFoto.getAttribute('x')) || 0;
      var fy = parseFloat(tubeFoto.getAttribute('y')) || 0;
      var fb = parseFloat(tubeFoto.getAttribute('width'));
      var fh = parseFloat(tubeFoto.getAttribute('height'));
      var sch = Math.min(fb / tubeBeeld.naturalWidth, fh / tubeBeeld.naturalHeight);
      var ib = tubeBeeld.naturalWidth * sch;
      var ih = tubeBeeld.naturalHeight * sch;
      var ix = fx + (fb - ib) / 2;
      var iy = fy + (fh - ih) / 2;
      // Het vak van de bak in bitmap-px, op hele pixels, met ruimte voor de
      // slagschaduw.
      var marge = Math.ceil((SLAG.sigma * 3 + SLAG.dy) * Math.max(kx, ky)) + 2;
      var x0 = Math.floor(ix * kx + tx) - marge;
      var y0 = Math.floor(iy * ky + ty) - marge;
      var x1 = Math.ceil((ix + ib) * kx + tx) + marge;
      var y1 = Math.ceil((iy + ih) * ky + ty) + marge;
      var bak = maakDoek(x1 - x0, y1 - y0);
      var p = bak.getContext('2d');
      p.imageSmoothingEnabled = true;
      p.imageSmoothingQuality = 'medium';
      p.setTransform(kx, 0, 0, ky, tx - x0, ty - y0);
      p.shadowColor = SLAG.kleur;
      p.shadowBlur = SLAG.sigma * 2 * (kx + ky) / 2;
      p.shadowOffsetX = SLAG.dx * kx;
      p.shadowOffsetY = SLAG.dy * ky;
      p.drawImage(tubeBeeld, ix, iy, ib, ih);

      // De bron voor de stroken: dezelfde bak, dubbel zo breed als de foto dat
      // heeft, anders wordt de opgerekte buik wazig. Alleen in de breedte: een
      // strook is één bitmap-px hoog en moet uit een bron komen die in de
      // hoogte even fijn is. Uit een bron die ook dubbel zo hoog is pakt elke
      // strook maar een deel van zijn twee rijen, en dat geeft kammetjes in
      // de tekst op het etiket zodra de tube langer of korter wordt. Daarom:
      // eerst op dubbele maat bakken (met de slagschaduw), dan in de hoogte
      // halveren.
      var q = tubeBeeld.naturalWidth >= ib * kx * 1.5 ? 2 : 1;
      var groot = bak;
      if (q > 1) {
        // Eerst de bak zelf laten uittekenen (door hem ergens op te zetten),
        // dan pas de foto op dubbele maat vragen. Chrome bewaart de foto per
        // maat; staat de grote er al, dan verkleint hij díe voor de bak en
        // wijkt de tekst op het etiket tot 12 van 255 af van de SVG-foto.
        maakDoek(1, 1).getContext('2d').drawImage(bak, 0, 0);
        var dubbel = maakDoek(bak.width * q, bak.height * q);
        p = dubbel.getContext('2d');
        p.imageSmoothingEnabled = true;
        p.imageSmoothingQuality = 'medium';
        p.setTransform(kx * q, 0, 0, ky * q, (tx - x0) * q, (ty - y0) * q);
        p.shadowColor = SLAG.kleur;
        p.shadowBlur = SLAG.sigma * 2 * q * (kx + ky) / 2;
        p.shadowOffsetX = SLAG.dx * kx * q;
        p.shadowOffsetY = SLAG.dy * ky * q;
        p.drawImage(tubeBeeld, ix, iy, ib, ih);
        groot = maakDoek(dubbel.width, bak.height);
        p = groot.getContext('2d');
        p.imageSmoothingEnabled = true;
        p.imageSmoothingQuality = 'high';
        p.drawImage(dubbel, 0, 0, dubbel.width, dubbel.height, 0, 0, dubbel.width, bak.height);
        geefVrij(dubbel);
      }

      // Het werkdoek voor de stroken: breed genoeg voor de bolste stand, hoog
      // genoeg voor een langere tube.
      var as = TUBE.as * kx + tx;
      var ruim = 1 + TUBE.bol * 1.25 + HAP.golfMaat + 0.1;
      var dx = Math.floor(as - (as - x0) * ruim) - 2;
      var dx1 = Math.ceil(as + (x1 - as) * ruim) + 2;
      var dy = y0 - Math.ceil(TUBE.voet * 0.12 * ky) - 2;
      var doek = maakDoek(dx1 - dx, y1 + 2 - dy);
      return {
        bak: bak, x: x0, y: y0, b: bak.width, h: bak.height,
        groot: groot, q: q,
        doek: doek, pen: doek.getContext('2d'), dx: dx, dy: dy,
        as: as,
        asKnijp: 524.44 * kx + tx,              // het punt waar .fh-scene__excl om schaalt
        top: TUBE.top * ky + ty,
        voet: TUBE.voet * ky + ty,
        lengte: (TUBE.voet - TUBE.top) * ky,
        glans: bakGlans()
      };
    }

    // De glanskaart: u (links..rechts over de tube) bij v (naad..voet). Donker
    // langs de randen (de bolling), een lichte baan links van het midden en
    // een hoogglansvlek op de schouder. Wordt per strook over de tube gelegd.
    function bakGlans() {
      var B = 96;
      var H = 128;
      var c = maakDoek(B, H);
      var p = c.getContext('2d');
      var g = p.createLinearGradient(0, 0, B, 0);
      g.addColorStop(0, 'rgba(70,12,52,' + (GLANS.donker * 0.8) + ')');
      g.addColorStop(0.16, 'rgba(70,12,52,0)');
      g.addColorStop(0.62, 'rgba(70,12,52,0)');
      g.addColorStop(1, 'rgba(70,12,52,' + GLANS.donker + ')');
      p.fillStyle = g;
      p.fillRect(0, 0, B, H);
      g = p.createLinearGradient(0, 0, B, 0);
      g.addColorStop(0, 'rgba(70,12,52,' + GLANS.rand + ')');
      g.addColorStop(0.03, 'rgba(70,12,52,' + (GLANS.rand * 0.6) + ')');
      g.addColorStop(0.06, 'rgba(70,12,52,0)');
      g.addColorStop(0.94, 'rgba(70,12,52,0)');
      g.addColorStop(0.97, 'rgba(70,12,52,' + (GLANS.rand * 0.6) + ')');
      g.addColorStop(1, 'rgba(70,12,52,' + GLANS.rand + ')');
      p.fillStyle = g;
      p.fillRect(0, 0, B, H);
      g = p.createLinearGradient(0, 0, B, 0);
      g.addColorStop(0.1, 'rgba(255,255,255,0)');
      g.addColorStop(0.27, 'rgba(255,255,255,' + (GLANS.licht * 0.55) + ')');
      g.addColorStop(0.46, 'rgba(255,255,255,0)');
      p.fillStyle = g;
      p.fillRect(0, 0, B, H);
      p.save();
      p.translate(B * 0.3, H * 0.3);
      p.scale(B * 0.17, H * 0.2);
      g = p.createRadialGradient(0, 0, 0, 0, 0, 1);
      g.addColorStop(0, 'rgba(255,255,255,' + GLANS.licht + ')');
      g.addColorStop(1, 'rgba(255,255,255,0)');
      p.fillStyle = g;
      p.beginPath();
      p.arc(0, 0, 1, 0, TWEE_PI);
      p.fill();
      p.restore();
      return c;
    }

    // Het bolprofiel langs de lengte (v: 0 = naad, 1 = voet): 0 bij de naad en
    // vanaf de dop, 1 op de buik.
    function bolProfiel(v) {
      var u = klem((v - 0.012) / (TUBE.kap - 0.012));
      return Math.pow(Math.sin(Math.PI * Math.pow(u, 0.86)), 0.8);
    }

    // Hoe breed is de tube op v (1 = zoals de foto)? De bolling plus de golven
    // van de happen die nog onderweg zijn.
    function tubeBreedte(v, s) {
      var w = 1;
      if (s.bol > 0) w += s.bol * TUBE.bol * bolProfiel(v);
      for (var i = 0; i < s.golven; i++) {
        var d = (v - s.golfV[i]) / HAP.golfBreed;
        w += s.golfA[i] * Math.exp(-d * d) * klem((1.02 - v) / 0.14);
      }
      return w;
    }

    function tubeHalf(v) {
      for (var i = 1; i < TUBE_HALF.length; i++) {
        if (v <= TUBE_HALF[i][0]) {
          var a = TUBE_HALF[i - 1];
          var b = TUBE_HALF[i];
          return a[1] + (b[1] - a[1]) * (v - a[0]) / (b[0] - a[0]);
        }
      }
      return TUBE_HALF[TUBE_HALF.length - 1][1];
    }

    // Tekent de tube op de voorste laag. s = tubeStand(t).
    function tekenTube(pen, s) {
      var T = GEO.tube;
      if (!T || s.foto <= 0.001) return;
      var L = s.lang * s.sy;               // lengtefactor, vanaf de voet
      var neutraal = s.bol < 0.0005 && !s.golven && Math.abs(L - 1) < 0.0002 &&
        Math.abs(s.sx - 1) < 0.0002 && Math.abs(s.zwaai) < 0.004;
      T.neutraal = neutraal;             // voor de lens van het water (tekenTubeKopie)
      pen.setTransform(1, 0, 0, 1, 0, 0);
      pen.globalAlpha = s.foto;
      if (neutraal) {
        pen.drawImage(T.bak, T.x, T.y);
      } else {
        var d = T.pen;
        d.setTransform(1, 0, 0, 1, 0, 0);
        d.globalCompositeOperation = 'source-over';
        d.globalAlpha = 1;
        d.clearRect(0, 0, T.doek.width, T.doek.height);
        d.setTransform(1, 0, 0, 1, -T.dx, -T.dy);
        var hB = 1;                        // stroken van één bitmap-px: zo blijft de schuine rand glad
        var hBron = hB / L;
        var yA = Math.floor(T.voet - (T.voet - T.y) * L);
        var yB = Math.ceil(T.voet + (T.y + T.h - T.voet) * L);
        var zwaaiPx = s.zwaai * GEO.kx;
        var y;
        var bron;
        var v;
        var S;
        // Stroken: bestemmingsrij y komt uit bronrij 'bron' (beide bitmap-px);
        // x' = asKnijp + (as + (x - as) * breedte - asKnijp) * sx.
        for (y = yA; y < yB; y += hB) {
          bron = T.voet - (T.voet - y) / L - T.y;
          if (bron < 0 || bron + hBron > T.h) continue;
          v = (bron + hBron / 2 + T.y - T.top) / T.lengte;
          S = tubeBreedte(v, s);
          d.drawImage(T.groot, 0, bron, T.b * T.q, hBron,
            T.asKnijp + (T.as + (T.x - T.as) * S - T.asKnijp) * s.sx + zwaaiPx * klem(1 - v), y,
            T.b * S * s.sx, hB);
        }
        // De glans en de schaduw van de bolling, alleen waar tube staat.
        if (s.bol > 0.004 || s.golven) {
          d.globalCompositeOperation = 'source-atop';
          var gB = T.glans.width;
          var gH = T.glans.height;
          for (y = yA; y < yB; y += hB) {
            bron = T.voet - (T.voet - y) / L - T.y;
            v = (bron + hBron / 2 + T.y - T.top) / T.lengte;
            if (v < 0 || v > 1) continue;
            S = tubeBreedte(v, s);
            var sterk = Math.min(1, (S - 1) / TUBE.bol);
            if (sterk < 0.01) continue;
            // Iets ruimer dan de tube zelf, zodat de donkere zoom van de
            // glanskaart over de uitsnijrand van de foto valt.
            var half = (tubeHalf(v) * GEO.kx + 1.5 * dpr) * S * s.sx;
            var midden = T.asKnijp + (T.as - T.asKnijp) * s.sx + zwaaiPx * klem(1 - v);
            d.globalAlpha = sterk;
            d.drawImage(T.glans, 0, Math.min(gH - 1, v * gH), gB, 1, midden - half, y, half * 2, hB);
          }
          d.globalCompositeOperation = 'source-over';
          d.globalAlpha = 1;
        }
        pen.drawImage(T.doek, T.dx, T.dy);
      }
      // De naad flitst vlak voor de poef (acht blokjes, zoals .fh-tube__naad).
      if (s.naad > 0.004) {
        pen.globalAlpha = s.foto * s.naad * 0.55;
        pen.fillStyle = INKT;
        var top = T.voet - (T.voet - T.top) * L;
        var hoog = 4.55 * GEO.ky * L;
        var Sn = tubeBreedte(0.017, s);
        for (var n = 0; n < 8; n++) {
          var xn = (501.2 + 5.81 * n) * GEO.kx + GEO.tx;
          var links = T.asKnijp + (T.as + (xn - T.as) * Sn - T.asKnijp) * s.sx + s.zwaai * GEO.kx;
          pen.fillRect(links, top, 3.02 * GEO.kx * Sn * s.sx, hoog);
        }
      }
      pen.globalAlpha = 1;
    }

    /* ======================================================================
       E. DE DUIK — rolStand(rol, t, uit) geeft voor elk moment waar een rol
       is en op welke laag:
         intocht  van buiten beeld naar zijn plek op de baan. Onderweg wisselt
                  hij niet van laag (zie INTOCHT en rol.inLaag)
         baan     hoek = fase + OMEGA * t, met baanPunt
         sprong   een boog van de baan naar het hangpunt boven de mond; hij
                  krimpt tot hij erin past. Wie van achter komt blijft op de
                  achterste laag (achter de letters en de tube) en komt boven
                  de naad geleidelijk ook op de voorste laag (uit.helder)
         plons    recht omlaag de tube in: smaller, langer, kleiner. Hij wordt
                  vóór de tube getekend en geknipt op de rand van de mond: wat
                  onder de rand komt is weg
       bouwDuiken legt per rol het vertrekpunt en de boog vast (die hangen van
       de baan af, dus van de maat van het vlak).
       ====================================================================== */
    var punt = { x: 0, y: 0, z: 0, schaal: 1 };

    function opBaan(rol, t, uit) {
      baanPunt(rol.fase + OMEGA * t, rol.r, uit);
      uit.y += rol.dy;
      return uit;
    }

    function bouwDuiken(xmin, xmax, luchtTop) {
      var maat = GEO.baan.maat;
      rollen.forEach(function (rol) {
        var R = rol.straal * rol.breedte * maat;      // omtrekstraal bij schaal 1
        // Intocht: op tIn staat hij net buiten beeld, aan de kant waar hij
        // vandaan komt.
        opBaan(rol, rol.tIn, punt);
        var kant = punt.z >= 0 ? 1 : -1;
        var buiten = kant > 0 ? xmax + R * 1.3 : xmin - R * 1.3;
        rol.inX = buiten - punt.x;
        rol.inY = -kant * INTOCHT.hoog;
        // Vertrek: plek en snelheid op de baan.
        opBaan(rol, rol.duik, punt);
        var x0 = punt.x;
        var y0 = punt.y;
        var z0 = punt.z;
        var s0 = punt.schaal;
        opBaan(rol, rol.duik + 0.01, punt);
        var vx = (punt.x - x0) / 0.01;
        var vy = (punt.y - y0) / 0.01;
        // Het hangpunt: recht boven de mond, met zijn onderkant DUIK.lucht
        // boven de rand; hij krimpt naar DUIK.zweef.
        var sH = Math.min(0.85, DUIK.zweef / R);
        var RH = R * sH;
        var hx = TUBE.as;
        var hy = TUBE.top - DUIK.lucht - RH;
        // De boog (kwadratisch): het stuurpunt ligt in het verlengde van de
        // vaart op de baan en DUIK.boog boven het hangpunt, maar de boog komt
        // nooit boven het vlak uit. Het hoogste punt van een kwadratische boog
        // is (P0 P2 - C^2)/(P0 - 2C + P2); daaruit volgt de hoogste C.
        var cx = x0 + vx * DUIK.sprong / 4;
        var cy = Math.min(y0 + vy * DUIK.sprong / 4, hy) - DUIK.boog;
        var plafond = luchtTop + RH + 1;
        cy = Math.max(cy, plafond - Math.sqrt(Math.max(0, y0 - plafond) * Math.max(0, hy - plafond)));
        rol.d = {
          x0: x0, y0: y0, z0: z0, s0: s0, cx: cx, cy: cy, hx: hx, hy: hy,
          sH: sH, R: R,
          yEind: TUBE.top + RH * 0.95,
          pxEind: Math.min(1, TUBE.mond * DUIK.smal / RH)
        };
      });
    }

    function rolStand(rol, t, uit) {
      uit.zicht = false;
      if (t < rol.tIn || t >= rol.tWeg) return uit;
      uit.zicht = true;
      uit.rol = rol;
      uit.hoek = rol.hoek0 + rol.tol * t;
      uit.px = 1;
      uit.py = 1;
      uit.knip = false;
      uit.schaduw = 1;
      uit.helder = 0;
      var maat = GEO.baan.maat;
      var d = rol.d;
      if (t < rol.duik) {
        // Op de baan, eventueel nog onderweg erheen.
        opBaan(rol, t, punt);
        uit.x = punt.x;
        uit.y = punt.y;
        uit.z = punt.z;
        uit.schaal = punt.schaal;
        var a = (t - rol.tIn) / rol.inDuur;
        if (a < 1) {
          var e = 1 - uitEase(a);
          uit.x += e * rol.inX;
          uit.y += e * rol.inY;
          uit.schaal *= 1 - (1 - INTOCHT.klein) * e;
        }
        // Op de baan bepaalt de diepte de laag. Alleen wie vroeg in zijn
        // intocht een uiteinde passeert, staat tot daar al op de laag van
        // erna (zie INTOCHT): hij is dan nog onderweg, boven het woord.
        uit.voor = rol.inLaag && t < rol.tKruis ? rol.inLaag > 0 : punt.z >= 0;
        uit.breedte = rol.breedte * maat * uit.schaal;
        return uit;
      }
      var u = (t - rol.duik) / DUIK.sprong;
      if (u < 1) {
        // De sprong: snel weg, uithangend boven de mond.
        var q = 1 - (1 - u) * (1 - u);
        var p = 1 - q;
        uit.x = p * p * d.x0 + 2 * p * q * d.cx + q * q * d.hx;
        uit.y = p * p * d.y0 + 2 * p * q * d.cy + q * q * d.hy;
        uit.schaal = d.s0 + (d.sH - d.s0) * glad(u);
        // Wie van achter komt blijft de hele sprong op de achterste laag: zo
        // gaat hij achter de letters en de tube langs omhoog. Boven de naad
        // komt hij daarnaast geleidelijk op de voorste laag ('helder', zie
        // teken): daar ligt de gloed van de svg niet meer over hem heen. In
        // één keer wisselen gaf een sprongetje in kleur.
        uit.voor = d.z0 >= 0;
        uit.z = uit.voor ? 2 : d.z0;
        uit.helder = uit.voor ? 0 : glad((u - DUIK.helder[0]) / (DUIK.helder[1] - DUIK.helder[0]));
        uit.schaduw = 1 - glad((u - 0.5) / 0.5);
        uit.breedte = rol.breedte * maat * uit.schaal;
        return uit;
      }
      // De plons.
      var w = (t - rol.tPlons) / DUIK.plons;
      var smal = glad(w / 0.42);
      uit.x = d.hx;
      uit.y = d.hy + (d.yEind - d.hy) * w * w;
      uit.schaal = d.sH * (1 - DUIK.klein * w);
      uit.px = 1 + (d.pxEind - 1) * smal;
      uit.py = 1 + DUIK.rek * smal;
      uit.voor = true;
      uit.knip = true;
      uit.schaduw = 0;
      uit.z = 3;
      uit.breedte = rol.breedte * maat * uit.schaal;
      return uit;
    }

    /* ======================================================================
       W. HET WATER — een straal die erbij geschonken wordt.
       Het pad is een worp: een kwadratische boog van een punt buiten beeld
       (rechtsboven) tot diep in de tube. De parameter van die boog is de tijd,
       dus het water versnelt zoals vallend water. Water dat op moment T het
       beeld in komt, zit op moment t op deel (t - T) / WATER.val van de boog.
       De straal beslaat op elk moment het water van de kop (T = giet) tot de
       staart (T = giet + duur). Alles wat de straal levend maakt (de golfjes
       in de dikte, het slingeren, de schaduwing) hangt aan T en valt dus met
       het water mee omlaag.
       Het water zelf: een gesloten vorm om het pad, geknipt op de rand van de
       mond, met daaroverheen de lichtbreking van echt water (de waterstrook,
       uit de foto van de waterbol), vermenigvuldigd over het papier: het
       heldere midden laat alles door, de randen worden donker. Geen getekende
       omtrek. De straal staat op de achterste laag: achter de gloed van de
       svg, net als wat er verder boven het woord vliegt, en achter wie er
       vóór hem langs de tube in duikt. Er wordt niets vervaagd en geen pixel
       gelezen.
       ====================================================================== */
    var wP = { x: 0, y: 0, tx: 0, ty: 1, v: 1 };
    var LICHT = [-0.45, -0.89];      // waar het licht vandaan komt (linksboven)
    var STROOK = [384, 48];          // de waterstrook: lengte x dikte (px)
    var W_STROOK = 350;              // px strook per seconde water

    // De waterstrook: hoe echt water licht breekt, uit de foto van de
    // waterbol in de sheet (druppel1). Elke kolom van de strook is één rij
    // dwars door die bol: donkere rand, helder midden, donkere rand. Langs de
    // strook schuift die rij op en neer door de bol, zodat de schaduwing langs
    // de straal verandert. Getekend met drawImage; er wordt niets gelezen.
    function bakWaterStrook() {
      var v = VAKKEN.druppel1;
      if (!sheet || !v) return null;
      var c = maakDoek(STROOK[0], STROOK[1]);
      var p = c.getContext('2d');
      p.fillStyle = '#fff';
      p.fillRect(0, 0, STROOK[0], STROOK[1]);
      var sf = sheet.naturalWidth / SHEET_B;
      var x;
      var mx = v[0] + 92;            // het midden van de bol in de sheet
      var my = v[1] + 147;
      var R = 85;                    // en zijn straal
      for (x = 0; x < STROOK[0]; x++) {
        var f = 0.5 - 0.5 * Math.cos(TWEE_PI * 2 * x / STROOK[0]);
        var dy = -30 + 92 * f;
        var half = Math.sqrt(R * R - dy * dy) - 1.5;
        p.save();
        p.translate(x, 0);
        p.rotate(Math.PI / 2);
        p.drawImage(sheet, (mx - half) * sf, (my + dy) * sf, half * 2 * sf, 1.5 * sf, 0, -1.25, STROOK[1], 1.5);
        p.restore();
      }
      // Helder water. Het midden van de bol is in de foto lichtgrijs; in de
      // straal staat dat als melk. Daarom het witpunt omlaag (alles lichter
      // dan WIT wordt wit, en dus onder 'multiply' doorzichtig) en daarna de
      // schaduwen dieper (de strook met zichzelf vermenigvuldigd): zo blijven
      // alleen de donkere randen en de breking over. Tot slot de kleur: de
      // rand van de bol is olijfbruin (hij spiegelt zijn omgeving), dat wordt
      // koel grijsblauw; de helderheid blijft die van de foto. Kent de browser
      // een van deze mengvormen niet, dan slaat hij die stap over.
      var WIT = 0.7;
      var grijs = Math.round(255 * (1 - WIT));
      p.globalCompositeOperation = 'color-dodge';
      if (p.globalCompositeOperation === 'color-dodge') {
        p.fillStyle = 'rgb(' + grijs + ',' + grijs + ',' + grijs + ')';
        p.fillRect(0, 0, STROOK[0], STROOK[1]);
      }
      p.globalCompositeOperation = 'multiply';
      if (p.globalCompositeOperation === 'multiply') {
        p.globalAlpha = 0.75;
        p.drawImage(c, 0, 0);
        p.globalAlpha = 1;
      }
      p.globalCompositeOperation = 'color';
      if (p.globalCompositeOperation === 'color') {
        p.fillStyle = '#9fb6c2';
        p.fillRect(0, 0, STROOK[0], STROOK[1]);
      }
      p.globalCompositeOperation = 'source-over';
      return c;
    }

    function bouwWater(luchtTop, zichtTop) {
      // De worp: opzij gaat het water gelijkmatig, omlaag versnelt het. Het
      // richtpunt van de boog ligt dus halverwege in x; WATER.vlak bepaalt hoe
      // steil hij begint. Het eindpunt ligt diep in de tube en iets voorbij
      // de as: zo valt de straal op de hoogte van de rand midden in de mond.
      var x0 = TUBE.as + WATER.van[0];
      var y0 = luchtTop - WATER.van[1];
      var x3 = TUBE.as - WATER.van[0] * 0.13;
      var y3 = TUBE.top + WATER.diep;
      var cx = (x0 + x3) / 2;
      var cy = y0 + (y3 - y0) * WATER.vlak;
      var papier = window.getComputedStyle(hero).backgroundColor;
      if (!papier || papier === 'transparent' || papier.replace(/\s/g, '') === 'rgba(0,0,0,0)') papier = '#FBF8F2';
      // Het natte doek: hierop komt per beeld de schaduwing van het water (op
      // halve maat: het is zacht), die dan in één keer over de straal gaat.
      var nat = maakDoek(Math.ceil(achter.width / 2), Math.ceil(achter.height / 2));
      var uit = {
        x0: x0, y0: y0, cx: cx, cy: cy, x3: x3, y3: y3,
        v0: 2 * Math.sqrt((cx - x0) * (cx - x0) + (cy - y0) * (cy - y0)) || 1,
        papier: papier, strook: bakWaterStrook(), beeld: null, nat: nat, natPen: nat.getContext('2d'),
        top: zichtTop - 2, vaag: penA.createLinearGradient(0, zichtTop - 2, 0, zichtTop - 2 + WATER.vaag)
      };
      uit.vaag.addColorStop(0, 'rgba(0,0,0,1)');
      uit.vaag.addColorStop(1, 'rgba(0,0,0,0)');
      // De strook als vast beeld: Safari kopieert een canvas dat als bron
      // dient bij elke drawImage opnieuw; een ImageBitmap niet. Tot hij er is
      // (of als het niet kan) dient het canvas zelf als bron.
      if (uit.strook && window.createImageBitmap) {
        try {
          window.createImageBitmap(uit.strook).then(function (b) {
            if (GEO && GEO.water === uit) uit.beeld = b;
            else if (b.close) b.close();
          }, function () {});
        } catch (fout) {}
      }
      return uit;
    }

    // Deel q (0..1) van de worp: de plek, de richting en de vaart (ten opzichte
    // van de vaart bovenaan).
    function worp(q, uit) {
      var Wg = GEO.water;
      var p = 1 - q;
      uit.x = p * p * Wg.x0 + 2 * p * q * Wg.cx + q * q * Wg.x3;
      uit.y = p * p * Wg.y0 + 2 * p * q * Wg.cy + q * q * Wg.y3;
      var dx = 2 * (p * (Wg.cx - Wg.x0) + q * (Wg.x3 - Wg.cx));
      var dy = 2 * (p * (Wg.cy - Wg.y0) + q * (Wg.y3 - Wg.cy));
      var v = Math.sqrt(dx * dx + dy * dy) || 1;
      uit.tx = dx / v;
      uit.ty = dy / v;
      uit.v = v / Wg.v0;
      return uit;
    }

    // De punten van de straal op moment t, van de staart (of de bovenrand van
    // het beeld) tot de kop (of diep in de tube): midden, normaal, halve
    // dikte. Water is nooit overal even dik: er lopen golfjes over de straal,
    // hij slingert, de kop is een dikke druppel met een ronde neus en de
    // staart snoert zich af tot een snoer van druppels.
    var wX = [];
    var wY = [];
    var wNx = [];
    var wNy = [];
    var wW = [];
    var wA = [];
    var wAantal = 0;
    var wVak = [0, 0, 0, 0];
    function waterRand(t) {
      var maat = GEO.baan.maat;
      var sinds = t - WATER.giet;
      var qH = Math.min(1, sinds / WATER.val);
      var qT = Math.max(0, (sinds - WATER.duur) / WATER.val);
      var n = 0;
      wAantal = 0;
      if (qH - qT < 1e-4) return;
      var q = qT;
      var laatste = false;
      while (!laatste && n < 240) {
        if (q >= qH) {
          q = qH;
          laatste = true;
        }
        worp(q, wP);
        var dH = sinds - q * WATER.val;      // zo veel later dan de kop kwam dit water het beeld in
        var dT = WATER.duur - dH;            // en zo veel eerder dan de staart
        // Hoe harder hij valt, hoe dunner de straal.
        var basis = WATER.dik * maat / Math.sqrt(wP.v);
        var neus = dH < 0.022 ? Math.sqrt(Math.max(0, 1 - Math.pow(1 - dH / 0.022, 2))) : 1;
        var kop = 1 + 0.22 * Math.exp(-Math.pow((dH - 0.03) / 0.022, 2));
        var staart = dT < 0.3 ? Math.pow(Math.sin(Math.max(0, dT) / 0.3 * Math.PI / 2), 0.9) : 1;
        var snoer = glad((0.22 - dT) / 0.18);
        var kraal = Math.pow(Math.abs(Math.sin(52 * dH)), 0.75);
        var golf = 1 + 0.2 * Math.sin(47 * dH) + 0.12 * Math.sin(83 * dH + 1.3) + 0.1 * Math.sin(19 * dH + 0.7);
        var w = basis * neus * kop * staart * golf * (1 - snoer * (1 - kraal) * 0.92) * (1 + snoer * 0.4);
        // Hij past altijd ruim in de mond.
        w = Math.min(w, TUBE.mond * 0.45);
        // Het slingeren neemt toe naarmate hij verder gevallen is.
        var slinger = Math.sin(31 * dH + 0.4) * 0.34 * basis * q;
        wX[n] = wP.x - wP.ty * slinger;
        wY[n] = wP.y + wP.tx * slinger;
        wNx[n] = -wP.ty;
        wNy[n] = wP.tx;
        wW[n] = w;
        wA[n] = dT;
        n++;
        // Fijner bij de kop (de neus is rond) en in de staart (de kralen).
        q += dH < 0.08 || dT < 0.3 ? 0.012 : 0.03;
      }
      wAantal = n;
      // Het omsluitende vak van de straal op het natte doek (halve bitmap-px,
      // hele pixels, binnen het doek): alleen dat deel wordt gewist, getekend
      // en overgezet.
      var x0 = Infinity;
      var y0 = Infinity;
      var x1 = -Infinity;
      var y1 = -Infinity;
      for (var i = 0; i < n; i++) {
        var r = wW[i] * 1.1 + 1;
        if (wX[i] - r < x0) x0 = wX[i] - r;
        if (wX[i] + r > x1) x1 = wX[i] + r;
        if (wY[i] - r < y0) y0 = wY[i] - r;
        if (wY[i] + r > y1) y1 = wY[i] + r;
      }
      var Wg = GEO.water;
      wVak[0] = Math.max(0, Math.floor((x0 * GEO.kx + GEO.tx) / 2) - 1);
      wVak[1] = Math.max(0, Math.floor((y0 * GEO.ky + GEO.ty) / 2) - 1);
      wVak[2] = Math.min(Wg.nat.width, Math.ceil((x1 * GEO.kx + GEO.tx) / 2) + 1) - wVak[0];
      wVak[3] = Math.min(Wg.nat.height, Math.ceil((y1 * GEO.ky + GEO.ty) / 2) + 1) - wVak[1];
    }
    function waterVorm(pen) {
      var i;
      pen.beginPath();
      pen.moveTo(wX[0] + wNx[0] * wW[0], wY[0] + wNy[0] * wW[0]);
      for (i = 1; i < wAantal; i++) pen.lineTo(wX[i] + wNx[i] * wW[i], wY[i] + wNy[i] * wW[i]);
      for (i = wAantal - 1; i >= 0; i--) pen.lineTo(wX[i] - wNx[i] * wW[i], wY[i] - wNy[i] * wW[i]);
      pen.closePath();
    }
    // Alleen de twee lange randen (niet de snijkant bovenaan).
    function waterRanden(pen) {
      var i;
      pen.beginPath();
      pen.moveTo(wX[0] + wNx[0] * wW[0], wY[0] + wNy[0] * wW[0]);
      for (i = 1; i < wAantal; i++) pen.lineTo(wX[i] + wNx[i] * wW[i], wY[i] + wNy[i] * wW[i]);
      pen.moveTo(wX[0] - wNx[0] * wW[0], wY[0] - wNy[0] * wW[0]);
      for (i = 1; i < wAantal; i++) pen.lineTo(wX[i] - wNx[i] * wW[i], wY[i] - wNy[i] * wW[i]);
    }

    // De schaduwing van de straal op het natte doek: per stukje een plakje
    // van de waterstrook, dwars op de straal. De strook hangt aan het water
    // (hij telt vanaf de kop), dus de schaduwing valt mee omlaag.
    function waterTextuur() {
      var Wg = GEO.water;
      var p = Wg.natPen;
      var h = 0.5;
      if (!Wg.strook || wVak[2] < 1 || wVak[3] < 1) return false;
      p.setTransform(1, 0, 0, 1, 0, 0);
      p.clearRect(wVak[0], wVak[1], wVak[2], wVak[3]);
      // Plakjes van twee punten lang: de omtrek zelf blijft fijn (het water
      // wordt erop geknipt), de schaduwing is zacht genoeg voor grotere
      // stappen. Dat scheelt tekenwerk: in Safari is elk plakje duur.
      var stap = 2;
      for (var i = 0; i < wAantal - 1; i += stap) {
        var j = Math.min(wAantal - 1, i + stap);
        var dx = wX[j] - wX[i];
        var dy = wY[j] - wY[i];
        var len = Math.sqrt(dx * dx + dy * dy);
        if (len < 1e-4) continue;
        var w = 0;
        for (var n = i; n <= j; n++) if (wW[n] > w) w = wW[n];
        w = w * 1.06 + 0.3;
        var ux = dx / len;
        var uy = dy / len;
        // Oorsprong op het punt dichter bij de kop, de x-as terug langs de
        // straal: zo loopt de strook in elk plakje dezelfde kant op en sluiten
        // de plakjes op elkaar aan.
        p.setTransform(-ux * GEO.kx * h, -uy * GEO.ky * h, -uy * GEO.kx * h, ux * GEO.ky * h,
          (wX[j] * GEO.kx + GEO.tx) * h, (wY[j] * GEO.ky + GEO.ty) * h);
        var sb = Math.max(0.5, (wA[j] - wA[i]) * W_STROOK);
        var sx = ((WATER.duur - wA[j]) * W_STROOK) % STROOK[0];
        if (sx < 0) sx += STROOK[0];
        if (sx + sb > STROOK[0]) sx = STROOK[0] - sb;
        p.drawImage(Wg.beeld || Wg.strook, sx, 0, sb, STROOK[1], -0.8, -w, len + 1.6, 2 * w);
      }
      return true;
    }

    // Tekent de straal die waterRand heeft klaargezet.
    function tekenStraal(pen, t) {
      var maat = GEO.baan.maat;
      var k = (GEO.kx + GEO.ky) / 2;
      var d = WATER.dik * maat;
      var i;
      zetWm(pen);
      // 1. Binnen het water: het papier, met de schaduwing van echt water
      //    eroverheen vermenigvuldigd. (Geen schaduw erachter: een scherpe
      //    schaduwkopie van zo'n dunne straal leest als een tweede rand.)
      pen.save();
      waterVorm(pen);
      pen.clip();
      pen.fillStyle = GEO.water.papier;
      pen.fill();
      if (waterTextuur()) {
        pen.setTransform(1, 0, 0, 1, 0, 0);
        pen.globalCompositeOperation = 'multiply';
        pen.imageSmoothingEnabled = true;
        pen.drawImage(GEO.water.nat, wVak[0], wVak[1], wVak[2], wVak[3], wVak[0] * 2, wVak[1] * 2, wVak[2] * 2, wVak[3] * 2);
        pen.globalCompositeOperation = 'source-over';
        zetWm(pen);
      }
      // 2. Een zweem van kleur.
      waterVorm(pen);
      pen.fillStyle = 'rgba(132,204,228,0.05)';
      pen.fill();
      // 3. Breking: naar de rand toe iets donkerder, zacht.
      pen.lineJoin = 'round';
      pen.lineCap = 'round';
      waterRanden(pen);
      pen.strokeStyle = 'rgba(20,66,92,0.1)';
      pen.lineWidth = d * 0.6;
      pen.stroke();
      pen.restore();
      // 4. Geen getekende omtrek: alleen een haardun randje, zodat de vorm op
      //    het papier niet rafelt. De donkere rand komt uit de foto.
      waterRanden(pen);
      pen.lineJoin = 'round';
      pen.lineCap = 'round';
      pen.strokeStyle = 'rgba(18,58,84,0.14)';
      pen.lineWidth = Math.max(0.7 / k, d * 0.06);
      pen.stroke();
      // 5. Glimlichten: korte vegen aan de lichtkant die naar hun uiteinden
      //    dun uitlopen (elk stukje zijn eigen dikte), geen doorgetrokken lijn.
      //    Ze glijden langzaam over het water.
      pen.strokeStyle = '#fff';
      pen.globalAlpha = 0.7;
      for (i = 0; i < wAantal - 1; i++) {
        var m = Math.sin(58 * wA[i] + 7 * t + 0.6);
        if (m < 0.35 || wW[i] < d * 0.25) continue;
        var kant = wNx[i] * LICHT[0] + wNy[i] * LICHT[1] >= 0 ? 1 : -1;
        pen.lineWidth = d * 0.2 * (m - 0.35) / 0.65;
        pen.beginPath();
        pen.moveTo(wX[i] + wNx[i] * kant * wW[i] * 0.42, wY[i] + wNy[i] * kant * wW[i] * 0.42);
        pen.lineTo(wX[i + 1] + wNx[i + 1] * kant * wW[i + 1] * 0.42, wY[i + 1] + wNy[i + 1] * kant * wW[i + 1] * 0.42);
        pen.stroke();
      }
      pen.globalAlpha = 1;
    }

    // Eén losse druppel (wm): een kraal die langs zijn vaart is uitgerekt, van
    // licht (linksboven) naar donker (rechtsonder, waar het licht breekt), met
    // een glimlicht. kleuren = [licht, midden, donker]; zonder is het water.
    // De pen staat al in wm.
    function tekenDruppel(pen, x, y, r, rek, hoek, dekking, kleuren) {
      var c = kleuren || SPAT.water;
      pen.save();
      pen.translate(x, y);
      pen.globalAlpha = dekking;
      var g = pen.createLinearGradient(-r * 0.6, -r * 0.8, r * 0.6, r * 0.8);
      g.addColorStop(0, c[0]);
      g.addColorStop(0.5, c[1]);
      g.addColorStop(1, c[2]);
      pen.rotate(hoek);
      pen.scale(rek, 1);
      pen.beginPath();
      pen.arc(0, 0, r, 0, TWEE_PI);
      pen.fillStyle = g;
      pen.fill();
      pen.scale(1 / rek, 1);
      pen.rotate(-hoek);
      pen.fillStyle = '#fff';
      pen.globalAlpha = dekking * 0.9;
      pen.beginPath();
      pen.arc(-r * 0.3, -r * 0.34, r * 0.26, 0, TWEE_PI);
      pen.fill();
      pen.restore();
      pen.globalAlpha = 1;
    }

    // Tekent het water van moment t op de achterste laag: de straal, en na
    // de staart de losse druppels die er nog achteraan vallen (elk zijn eigen
    // maat, plek en rek).
    function tekenWater(pen, t) {
      waterRand(t);
      if (wAantal > 1) tekenStraal(pen, t);
      var maat = GEO.baan.maat;
      zetWm(pen);
      for (var j = 0; j < WATER.druppels; j++) {
        var h1 = hash(j + 1.7, 3.1);
        var h2 = hash(j * 2.3 + 0.4, 7.7);
        var h3 = hash(j + 9.1, 5.3);
        var q = (t - WATER.giet - WATER.duur - 0.012 - 0.26 * h1 * h1) / WATER.val;
        if (q <= 0 || q >= 1) continue;
        worp(q, wP);
        var basis = WATER.dik * maat / Math.sqrt(wP.v);
        var opzij = (h2 - 0.5) * 1.6 * basis * (0.3 + q);
        tekenDruppel(pen, wP.x - wP.ty * opzij, wP.y + wP.tx * opzij, basis * (0.16 + 0.34 * h3 * h3),
          1.2 + 0.5 * wP.v, Math.atan2(wP.ty, wP.tx), 1);
      }
      // De straal komt van buiten beeld: onder de bovenrand van het beeld
      // (GEO.water.top) loopt hij zacht uit in het papier in plaats van met
      // een harde snede te beginnen. Het water is het eerste wat op deze laag
      // komt, dus er wordt niets anders uitgeveegd.
      var Wg = GEO.water;
      pen.globalCompositeOperation = 'destination-out';
      pen.fillStyle = Wg.vaag;
      pen.fillRect(Wg.x3 - 30, Wg.top - 80, Wg.x0 - Wg.x3 + 60, WATER.vaag + 80);
      pen.globalCompositeOperation = 'source-over';
    }

    /* ======================================================================
       F. SLIK EN VOL — tubeStand(t) telt de happen op tot de stand van de
       tube. Elke hap (op rol.tSlik) geeft:
         een stap boller (HAP.zwel, met de schok van HAP.ease erin);
         een golf die van de naad naar de dop loopt (HAP.golf);
         een schok: de tube veert even in en terug (HAP.schok).
       Daarbovenop wat de timeline stuurt: trillen (tube.tril), leegknijpen
       (tube.leeg) en de knijp van .fh-scene__excl (schaal, uit GSAP's eigen
       boekhouding: geen meting in de DOM).
       ====================================================================== */
    var stand = { bol: 0, bolVast: 0, lang: 1, zwaai: 0, golven: 0, golfV: [], golfA: [], sx: 1, sy: 1, foto: 1, naad: 0, rand: 0 };

    function tubeStand(t) {
      var s = stand;
      var bol = 0;
      var schok = 0;
      s.golven = 0;
      for (var i = 0; i < rollen.length; i++) {
        var r = rollen[i];
        var u = t - r.tSlik;
        if (u <= 0) continue;
        bol += r.hap * zwelEase(Math.min(1, u / HAP.zwel));
        if (u < HAP.golf) {
          var g = u / HAP.golf;
          s.golfV[s.golven] = g * 1.05;
          s.golfA[s.golven] = HAP.golfMaat * (0.15 + 0.85 * Math.sqrt(r.hap / 0.35)) * Math.sin(Math.PI * Math.pow(g, 0.6));
          s.golven++;
        }
        if (u < HAP.schok) {
          var x = u / HAP.schok;
          schok += (0.1 + 0.9 * Math.sqrt(r.hap / 0.35)) * Math.exp(-3.2 * x) * Math.sin(3 * Math.PI * x) * (1 - x);
        }
      }
      // Het water: zodra de kop van de straal de mond raakt een slik, daarna
      // vult de tube gestaag tot de staart erin is.
      var uw = t - W_T0;
      if (uw > 0) {
        bol += W_HAP * glad(uw / (W_T1 - W_T0));
        if (uw < HAP.golf) {
          var gw = uw / HAP.golf;
          s.golfV[s.golven] = gw * 1.05;
          s.golfA[s.golven] = HAP.golfMaat * 0.7 * Math.sin(Math.PI * Math.pow(gw, 0.6));
          s.golven++;
        }
        if (uw < HAP.schok) {
          var xw = uw / HAP.schok;
          schok += 0.75 * Math.exp(-3.2 * xw) * Math.sin(3 * Math.PI * xw) * (1 - xw);
        }
      }
      bol *= 1 - tube.leeg;
      s.bolVast = Math.max(0, bol);        // zonder het trillen: hiermee wijken de letters
      var tril = tube.tril * (1 - tube.leeg);
      if (tril > 0) {
        bol *= 1 + VOL.bol * tril * Math.sin(TWEE_PI * VOL.hz * t);
        s.zwaai = VOL.zwaai * tril * Math.sin(TWEE_PI * VOL.hz * 0.5 * t + 1);
      } else {
        s.zwaai = 0;
      }
      s.bol = Math.max(0, bol);
      s.lang = 1 + TUBE.lang * s.bol - HAP.krimp * schok * (1 - tube.leeg);
      s.sx = gsap.getProperty(excl, 'scaleX') * gsap.getProperty(buik, 'scaleX');
      s.sy = gsap.getProperty(excl, 'scaleY') * gsap.getProperty(buik, 'scaleY');
      s.foto = tube.foto;
      s.naad = tube.naad;
      // De rand van de mond (wm): daar wordt een duiker geknipt.
      s.rand = TUBE.voet - (TUBE.voet - TUBE.top) * s.lang * s.sy;
      return s;
    }

    // Spatten sap bij elke hap: een paar druppels die uit de mond opspringen
    // en terugvallen, uitgerekt langs hun vaart. Vast per hap (hash), dus elke
    // keer hetzelfde. Zolang de straal water erin valt spat ook dat. En als de
    // k en de y de volle tube leegknijpen, spuit er een laatste pluim uit.
    function spat(pen, s, u, h1, h2, h3, kleuren, maat, vaart0, vaart1) {
      var richting = (-90 + (h1 - 0.5) * 124) * RAD;
      var vaart = vaart0 + vaart1 * h2;
      var vx = Math.cos(richting) * vaart;
      var vy = Math.sin(richting) * vaart + 840 * u;
      var x = TUBE.as + (h1 - 0.5) * TUBE.mond * 1.2 + Math.cos(richting) * vaart * u;
      var y = s.rand - 1 + Math.sin(richting) * vaart * u + 420 * u * u;
      if (y > s.rand + 2) return;
      var a = 1 - u / HAP.spat;
      var snel = Math.sqrt(vx * vx + vy * vy);
      tekenDruppel(pen, x, y, (1.3 + 2.0 * h3) * (0.6 + 0.4 * a) * maat, 1 + Math.min(1.5, snel / 170),
        Math.atan2(vy, vx), Math.min(1, a * 1.7), kleuren);
    }
    function tekenSpatten(pen, t, s) {
      var maat = GEO.baan.maat;
      var u;
      var j;
      zetWm(pen);
      for (var i = 0; i < rollen.length; i++) {
        var r = rollen[i];
        u = t - r.tSlik;
        if (u <= 0 || u >= HAP.spat) continue;
        var n = 3 + Math.round(10 * r.hap);
        for (j = 0; j < n; j++) spat(pen, s, u, hash(i + 1.3, j + 0.7), hash(j + 2.1, i + 5.9), hash(i * 3.7 + j, 9.2), r.spat, maat, 70, 130);
      }
      // Zolang de straal water erin valt: om de 45 ms een spat water.
      if (t > W_T0 && t < W_T1 + HAP.spat) {
        var m1 = Math.floor((t - W_T0) / 0.045);
        for (var m = Math.max(0, m1 - 9); m <= m1; m++) {
          var tm = W_T0 + m * 0.045;
          if (tm > W_T1) break;
          u = t - tm;
          if (u >= HAP.spat) continue;
          spat(pen, s, u, hash(m + 0.37, 4.1), hash(m * 1.7, 8.3), hash(m + 6.6, 1.9), SPAT.water, maat, 60, 120);
        }
      }
      // De pluim bij het leegknijpen.
      u = t - T_PUF;
      if (u > 0 && u < HAP.spat) {
        for (j = 0; j < 11; j++) {
          spat(pen, s, u, hash(j + 0.21, 12.7), hash(j * 1.9 + 3, 2.2), hash(j + 4.4, 7.1),
            j % 3 === 0 ? SPAT.water : j % 3 === 1 ? SPAT.rood : SPAT.groen, maat, 120, 150);
        }
      }
      pen.globalAlpha = 1;
    }

    /* ======================================================================
       Bouwen en tekenen
       ====================================================================== */
    // De bakken van de vorige maat weg.
    function ruimOp() {
      if (!GEO) return;
      Object.keys(GEO.sprites).forEach(function (naam) {
        geefVrij(GEO.sprites[naam].beeld);
        geefVrij(GEO.sprites[naam].schaduw);
      });
      if (GEO.tube) {
        geefVrij(GEO.tube.bak);
        geefVrij(GEO.tube.groot);
        geefVrij(GEO.tube.doek);
        geefVrij(GEO.tube.glans);
      }
      if (GEO.water) {
        geefVrij(GEO.water.nat);
        geefVrij(GEO.water.strook);
        if (GEO.water.beeld && GEO.water.beeld.close) GEO.water.beeld.close();
      }
      GEO = null;
    }

    // Alles wat van de maat van het vlak afhangt: de lagen, de omrekening van
    // wm naar bitmap-px (uit de CTM van de letters), de baan, de gebakken
    // sprites, de gebakken tube en de duikpaden. Verandert de timeline niet.
    function bouw() {
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      // Eerst de rechthoeken (die dwingen een verse layout af), dan pas de CTM.
      var m = meetVlak();
      var sr = m.sr;
      var c0 = grond.getCTM();
      if (!c0 || !(c0.a > 0) || sr.width < 4 || sr.height < 4) {
        ruimOp();
        sleutel = '';
        return;
      }
      var nieuw = [sr.width, sr.height, m.links.toFixed(3), m.boven.toFixed(3), m.dx.toFixed(3), m.dy.toFixed(3), c0.a, c0.d, c0.e, c0.f, dpr, !!sheet, !!tubeBeeld].join(' ');
      if (nieuw === sleutel && GEO) {
        plaatsLagen('vast', m);
        return;
      }
      ruimOp();
      plaatsLagen('nieuw', m);
      vuil = true;
      // Van wm naar bitmap-px: de CTM van de letters (CSS-px binnen de svg)
      // plus de plek van de getekende svg binnen de laag (zie meetVlak), maal
      // dpr. Gemeten in Chrome en in WebKit: zo valt de gebakken tube samen
      // met de SVG-foto; de svg wordt dus niet opgerekt naar hele pixels.
      var kx = c0.a * dpr;
      var ky = c0.d * dpr;
      var tx = (c0.e + m.dx) * dpr;
      var ty = (c0.f + m.dy) * dpr;
      var xmin = -tx / kx;
      var xmax = (voor.width - tx) / kx;
      // Hoogste punt (wm, uit de CSS) dat een sprite mag halen: op desktop is
      // de bovenste strook van de lucht weggeknipt.
      var stijl = window.getComputedStyle(hero);
      var luchtTop = parseFloat(stijl.getPropertyValue('--fh-lucht-top'));
      if (isNaN(luchtTop)) luchtTop = -106;
      // De bovenrand van wat je ziet (wm). Sinds 04-10 knipt de CSS meer van de
      // lucht weg dan de baan hoog is (.fh-hero2--hoog): de stukjes mogen daar
      // even uit beeld. De baan rekent dus nog met luchtTop; alleen de
      // waterstraal moet weten waar het beeld begint.
      var zichtTop = parseFloat(stijl.getPropertyValue('--fh-zicht-top'));
      if (isNaN(zichtTop)) zichtTop = luchtTop;
      GEO = { kx: kx, ky: ky, tx: tx, ty: ty, xmin: xmin, xmax: xmax, luchtTop: luchtTop, sprites: {}, tube: null };
      GEO.baan = bouwBaan(xmin, xmax, c0.a, luchtTop);
      if (sheet) GEO.sprites = bakSprites((kx + ky) / 2, GEO.baan.maat);
      GEO.tube = bakTube(kx, ky, tx, ty);
      bouwDuiken(xmin, xmax, luchtTop);
      GEO.water = bouwWater(luchtTop, zichtTop);
      sleutel = nieuw;
    }

    var staten = rollen.map(function () { return { zicht: false }; });
    var lijstA = [];
    var lijstV = [];
    var lijstP = [];
    var lijstH = [];
    function opDiepte(a, b) {
      return a.z - b.z || a.rol.nr - b.rol.nr;
    }
    var optie = { dekking: 1, spiegel: 1, px: 1, py: 1, schaduw: 1 };
    // helder: de tweede, heldere tekening van een rol op de voorste laag (zie
    // rolStand, de sprong): met zijn dekking van dat moment en zonder schaduw.
    function tekenRol(pen, st, helder) {
      optie.dekking = helder ? st.helder : 1;
      optie.spiegel = st.rol.spiegel;
      optie.px = st.px;
      optie.py = st.py;
      optie.schaduw = helder ? 0 : st.schaduw;
      tekenSprite(pen, st.rol.sprite, st.x, st.y, st.breedte, st.hoek, optie);
    }

    // Tekent het moment t: de k en de y, de foto, en de twee lagen.
    var wasOpDoek = false;
    function teken(t) {
      var s = tubeStand(t);
      zetLetters(tube.spleet, s.bolVast);
      // Twee momenten waarop het nauw komt: de lagen gaan aan (de eerste
      // sprite) en de tube gaat van de SVG-foto naar het canvas. Dan eerst
      // nameten of het vlak nog ligt waar het lag toen er gebouwd werd: de
      // pagina kan intussen een fractie verschoven zijn (letters die laden,
      // een balk die verschijnt) en dan stond de tube een halve px naast de
      // foto. bouw() meet en herbouwt alleen als er iets veranderd is; dit is
      // dus geen meting per beeld.
      var naarDoek = tube.doek > 0.5;
      if (GEO && ((naarDoek && !wasOpDoek) ||
          (!lagenAan && (debug || (naarDoek && tube.foto > 0.001) || (sheet && t >= T_IN && t < Math.min(T_UIT, T_LEEG)))))) {
        try {
          bouw();
        } catch (fout) {
          GEO = null;
        }
      }
      wasOpDoek = naarDoek;
      var opDoek = !!(GEO && GEO.tube && naarDoek);
      zetFoto(!opDoek, tube.foto);
      if (!GEO) {
        toonLagen(false);
        return;
      }
      var i;
      lijstA.length = 0;
      lijstV.length = 0;
      lijstP.length = 0;
      lijstH.length = 0;
      if (sheet && t < T_LEEG) {
        for (i = 0; i < rollen.length; i++) {
          var st = rolStand(rollen[i], t, staten[i]);
          if (!st.zicht) continue;
          if (st.knip) lijstP.push(st);
          else if (st.voor) lijstV.push(st);
          else {
            lijstA.push(st);
            if (st.helder > 0.004) lijstH.push(st);
          }
        }
      }
      var tubeAan = opDoek && s.foto > 0.001;
      var spat = sheet && t > T_PLONS && t < Math.max(T_VOL, T_PUF) + HAP.spat;
      var nat = !!(sheet && GEO.water && t > WATER.giet && t < W_EIND);
      if (!lijstA.length && !lijstV.length && !lijstP.length && !tubeAan && !spat && !nat && !debug) {
        if (vuil) wis();
        toonLagen(false);
        return;
      }
      toonLagen(true);
      wis();
      vuil = true;
      // Achter: eerst de straal water (geknipt op de rand van de mond), dan
      // de sprites van ver naar dichtbij.
      if (nat) {
        penA.save();
        zetWm(penA);
        penA.beginPath();
        penA.rect(GEO.xmin - 10, -400, GEO.xmax - GEO.xmin + 20, 400 + s.rand + 0.25);
        penA.clip();
        tekenWater(penA, t);
        penA.restore();
      }
      lijstA.sort(opDiepte);
      for (i = 0; i < lijstA.length; i++) tekenRol(penA, lijstA[i]);
      // Voor: eerst wie de tube in gaat (geknipt op de rand van de mond, of
      // de tube nu nog de SVG-foto is of al op het canvas staat), dan de tube,
      // dan wat voorlangs vliegt.
      if (lijstP.length) {
        penV.save();
        zetWm(penV);
        penV.beginPath();
        penV.rect(GEO.xmin - 10, -400, GEO.xmax - GEO.xmin + 20, 400 + s.rand + 0.25);
        penV.clip();
        for (i = 0; i < lijstP.length; i++) tekenRol(penV, lijstP[i]);
        penV.restore();
      }
      if (tubeAan) tekenTube(penV, s);
      if (spat) tekenSpatten(penV, t, s);
      lijstV.sort(opDiepte);
      for (i = 0; i < lijstV.length; i++) tekenRol(penV, lijstV[i]);
      // Wie uit de diepte omhoog springt: boven de naad (daar staan geen
      // letters en geen tube) ook op de voorste laag, steeds helderder.
      if (lijstH.length) {
        penV.save();
        zetWm(penV);
        penV.beginPath();
        penV.rect(GEO.xmin - 10, -400, GEO.xmax - GEO.xmin + 20, 400 + Math.min(TUBE.top, s.rand) - 1.5);
        penV.clip();
        for (i = 0; i < lijstH.length; i++) tekenRol(penV, lijstH[i], true);
        penV.restore();
      }
      if (debug) tekenDebug(penV, t, s);
    }

    // ?fh_debug=1: de baan (voor doorgetrokken, achter gestippeld), de
    // wisselpunten met de omtrek van de grootste sprite, de grens tot waar
    // letters staan, de duikbogen, de rand van de mond, het plafond, het
    // scènevlak en om elke rol zijn omtrek (teal = voorste laag, berry =
    // achterste).
    function tekenDebug(pen, t, s) {
      if (debug === 'tube') return;
      var B = GEO.baan;
      var i;
      zetWm(pen);
      pen.lineWidth = 1 / GEO.kx;
      pen.globalAlpha = 1;
      [[0, Math.PI, MERK.teal, []], [Math.PI, TWEE_PI, MERK.berry, [6, 5]]].forEach(function (deel) {
        pen.strokeStyle = deel[2];
        pen.setLineDash(deel[3]);
        pen.beginPath();
        for (var a = deel[0]; a <= deel[1] + 0.001; a += Math.PI / 60) {
          baanPunt(a, 1, punt);
          if (a === deel[0]) pen.moveTo(punt.x, punt.y);
          else pen.lineTo(punt.x, punt.y);
        }
        pen.stroke();
      });
      pen.setLineDash([]);
      var grootst = 0;
      rollen.forEach(function (r) { grootst = Math.max(grootst, r.d.R); });
      pen.strokeStyle = '#E0457B';
      [0, Math.PI].forEach(function (a) {
        baanPunt(a, 1, punt);
        pen.beginPath();
        pen.arc(punt.x, punt.y, grootst, 0, TWEE_PI);
        pen.stroke();
        pen.beginPath();
        pen.arc(punt.x, punt.y, 2, 0, TWEE_PI);
        pen.stroke();
      });
      pen.strokeStyle = '#E0457B';
      pen.beginPath();
      pen.moveTo(-WOORD + B.cx, -20);
      pen.lineTo(-WOORD + B.cx, 150);
      pen.moveTo(WOORD + B.cx, -20);
      pen.lineTo(WOORD + B.cx, 150);
      pen.stroke();
      pen.strokeStyle = MERK.taupe;
      rollen.forEach(function (r) {
        var d = r.d;
        pen.beginPath();
        pen.moveTo(d.x0, d.y0);
        pen.quadraticCurveTo(d.cx, d.cy, d.hx, d.hy);
        pen.lineTo(d.hx, d.yEind);
        pen.stroke();
      });
      pen.strokeStyle = MERK.teal;
      pen.beginPath();
      pen.moveTo(TUBE.as - 40, s.rand);
      pen.lineTo(TUBE.as + 40, s.rand);
      pen.moveTo(GEO.xmin, GEO.luchtTop);
      pen.lineTo(GEO.xmax, GEO.luchtTop);
      pen.stroke();
      // Het scènevlak zelf (de viewBox), gestippeld, met een kruis in de
      // bovenste strook: op desktop knipt .fh-frankly die strook weg, dan zie
      // je de bovenrand en het kruis niet.
      pen.setLineDash([3, 3]);
      pen.strokeStyle = MERK.taupe;
      pen.strokeRect(-19, -109, 701.862, 290.69);
      pen.beginPath();
      pen.moveTo(300, -108);
      pen.lineTo(364, -86);
      pen.moveTo(364, -108);
      pen.lineTo(300, -86);
      pen.stroke();
      pen.setLineDash([]);
      for (i = 0; i < staten.length; i++) {
        var st = staten[i];
        if (!st.zicht) continue;
        pen.strokeStyle = st.voor ? MERK.teal : MERK.berry;
        pen.beginPath();
        pen.arc(st.x, st.y, st.rol.d.R * st.schaal, 0, TWEE_PI);
        pen.stroke();
      }
    }

    tl.eventCallback('onUpdate', function () {
      teken(tl.time());
    });

    function zet(t) {
      tl.pause(t);
      teken(tl.time());
      return {
        sprites: rollen.length,
        morph: M0,
        geladen: !!(GEO && sheet && GEO.tube),
        bol: Math.round(stand.bol * 1000) / 1000,
        tubeOpDoek: !!(GEO && GEO.tube && tube.doek > 0.5)
      };
    }
    // Wie zet() van buiten aanroept (QA) neemt de regie over: komen de plaatjes
    // pas daarna binnen, dan wordt dat moment opnieuw getekend en begint de
    // hero niet alsnog te spelen (zie speel).
    var handmatig = false;
    window.fhAkker = {
      tl: tl,
      zet: function (t) {
        handmatig = true;
        return zet(t);
      }
    };

    // Verandert de maat (venster, of alleen het vlak: een schuifbalk die
    // verschijnt): de lagen meteen meeschalen, kort daarna opnieuw bouwen en
    // het moment van nu tekenen. De timeline loopt gewoon door, dus er
    // verspringt niets. bouw() doet niets als de maat gelijk is gebleven (op
    // een telefoon vuurt resize bij elke beweging van de adresbalk).
    var wachtOpMaat = null;
    var kijker = null;
    function opMaat() {
      if (!document.documentElement.contains(hero)) {
        // De sectie is vervangen (thema-editor): opruimen.
        window.removeEventListener('resize', opMaat);
        if (kijker) kijker.disconnect();
        window.clearTimeout(wachtOpMaat);
        tl.kill();
        return;
      }
      if (GEO && lagenAan) plaatsLagen('rek');
      window.clearTimeout(wachtOpMaat);
      wachtOpMaat = window.setTimeout(function () {
        if (!klaar) return;
        try {
          bouw();
        } catch (fout) {
          GEO = null;
        }
        teken(tl.time());
      }, 150);
    }
    window.addEventListener('resize', opMaat);
    if (window.ResizeObserver) {
      kijker = new window.ResizeObserver(opMaat);
      kijker.observe(svg);
    }

    /* ---- Start ------------------------------------------------------------ */
    // Pas als de tube en de sheet er zijn en de pagina zichtbaar is. Laadt een
    // van beide niet (fout, of niet binnen 2,5 s), dan speelt de rustige
    // variant.
    var gestart = false;
    var terugval = false;
    var rustigBezig = false;
    var qa = parseFloat(vraag.get('fh_t'));
    function speel() {
      if (gestart) return;
      gestart = true;
      if (handmatig) {
        teken(tl.time());
        return;
      }
      if (qa >= 0) {
        zet(qa / 1000);
        return;
      }
      if (rustig || terugval) return rustigSpelen();
      tl.play(0);
    }

    // Met 'Verminder beweging' aan: alleen het woord met de tube, die ter plekke
    // overvloeit in het getekende uitroepteken; daarna de claims en het
    // onderschrift. Geen ingrediënten, geen lucht en niets dat verschuift
    // (02-10, op verzoek van de eigenaar). Het eindbeeld staat meteen; alleen de
    // tube staat er nog in, en de k en de y staan al op hun plek (ook in de
    // beginstand, zie assets/frankly-akker.css).
    function rustigSpelen() {
      rustigBezig = true;
      zet(tl.duration());
      gsap.set([achter, voor], { autoAlpha: 0 });
      if (lucht) gsap.set(lucht, { opacity: 0 });
      gsap.set(tubeFoto, { autoAlpha: 1 });
      gsap.set([lijf, dop], { opacity: 0 });
      gsap.set(claims.concat(letters), { opacity: 0 });
      // Subtiel (07-10, op verzoek van de eigenaar: 'laat de tube op een
      // subtiele manier veranderen in het uitroepteken'): de tube wordt ter
      // plekke smaller terwijl hij vervaagt, en het teken komt iets breder op
      // en trekt zich samen tot zijn eigen maat. Ze ontmoeten elkaar halverwege,
      // op de onderkant van het teken; niets verplaatst zich (hooguit een paar
      // pixels in de breedte). Daarna gaan alle transforms er weer af.
      gsap.set([lijf, dop], { scaleX: 1.35, svgOrigin: '21.5 130' });
      // QA: window.fhAkker.rustig is deze tijdlijn (pause().seek(t)).
      var rustigTl = gsap.timeline({ delay: 1.0, onComplete: function () { gsap.set([tubeFoto, lijf, dop], { clearProps: 'transform' }); } })
        .to(tubeFoto, { scaleX: 0.55, scaleY: 0.97, svgOrigin: '522.4 130', duration: 1.4, ease: 'sine.inOut' })
        .to(tubeFoto, { autoAlpha: 0, duration: 0.8, ease: 'sine.in' }, 0.5)
        .to([lijf, dop], { opacity: 1, duration: 0.8, ease: 'sine.out' }, 0.5)
        .to([lijf, dop], { scaleX: 1, svgOrigin: '21.5 130', duration: 1.0, ease: 'sine.out' }, 0.4)
        .to(claims.concat(letters), { opacity: 1, duration: 0.5, ease: 'none' }, '+=0.2');
      if (window.fhAkker) window.fhAkker.rustig = rustigTl;
    }
    function wanneerZichtbaar() {
      if (document.visibilityState !== 'hidden') return speel();
      document.addEventListener('visibilitychange', function wacht() {
        if (document.visibilityState === 'hidden') return;
        document.removeEventListener('visibilitychange', wacht);
        speel();
      });
    }

    var klaar = false;
    function ladenKlaar() {
      if (klaar) return;
      klaar = true;
      terugval = !sheet || !tubeBeeld;
      try {
        bouw();
      } catch (fout) {
        GEO = null;
        terugval = true;
      }
      wanneerZichtbaar();
    }
    // Komt een plaatje pas binnen nadat er al gestart is (alleen bij ?fh_t of
    // zet(): de rustige variant blijft rustig), dan opnieuw bouwen en het
    // moment van nu opnieuw tekenen.
    function binnen() {
      if (!klaar) {
        if ((sheet || rustig) && tubeBeeld) ladenKlaar();
        return;
      }
      if (rustigBezig) return;
      if (!gestart) terugval = !sheet || !tubeBeeld;
      try {
        bouw();
        teken(tl.time());
      } catch (fout) {
        GEO = null;
      }
    }
    function laad(url, klaarMet) {
      if (!url) return ladenKlaar();
      var beeld = new Image();
      beeld.addEventListener('load', function () {
        if (!beeld.naturalWidth) return ladenKlaar();
        klaarMet(beeld);
        binnen();
      }, { once: true });
      beeld.addEventListener('error', ladenKlaar, { once: true });
      beeld.src = url;
    }
    // Hero 'geel' (19-10-2026): de getekende sheet (frankly-baan-sprites-getekend.png),
    // dus geen zachte schaduw onder de stukjes en vlakke spatjes in merkkleuren
    // (de tekenstijl: vlak + inktrand, geen glans of verloop).
    if (hero.classList.contains('fh-hero2--geel')) {
      SCHADUW.dekking = 0;
      SPAT.rood = ['#E89CDB', '#83245F', '#83245F'];
      SPAT.groen = ['#96E2C0', '#00A19C', '#00A19C'];
    }
    laad(tubeFoto.getAttribute('href') || tubeFoto.getAttribute('xlink:href'), function (b) { tubeBeeld = b; });
    // Met 'Verminder beweging' speelt de rustige variant: die heeft de sheet
    // niet nodig, dus niet ophalen en er niet op wachten.
    if (!rustig) {
      laad(hero.getAttribute('data-baan-sprites'), function (b) {
        // Alleen een sheet met de verhouding van VAKKEN; met een andere
        // (script en sheet van verschillende versies) zou het script naast de
        // stukjes knippen. Dan liever meteen de rustige variant.
        if (Math.abs(b.naturalHeight / b.naturalWidth - SHEET_H / SHEET_B) < 0.01) sheet = b;
        else ladenKlaar();
      });
    }
    window.setTimeout(ladenKlaar, 2500);
  }

  function alle() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-frankly-baan]'), start);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle);
  else alle();
  document.addEventListener('shopify:section:load', function (e) {
    var hero = e.target && e.target.querySelector ? e.target.querySelector('[data-frankly-baan]') : null;
    if (hero) start(hero);
  });
})();
